import {ITemplate} from "./../components/template-preview/template-preview.component";
import {Utils} from "./../utils";
import {TutorialPanelComponent} from "./../components/tutorial-panel/tutorial-panel.component";
import {AlertState} from "./../enums/alert-state";
import {AlertStateEntry} from "./alert-state-entry";
import {
    NewAlert,
    AlertRead,
    AlertStateChanged,
    ILeaderBoardReq,
    ILeaderBoardRs,
    IOrdersHistoryData
} from "./../interfaces/service.response";
import {
    SettingsClient,
    TournamentClient,
    AccountsClient,
    Account,
    UserTournamentsResponse,
    TournamentWithAccountId,
    LeaderBoardResponse,
    Leaderboard,
    TournamentUserAndAccount,
    IAccount,

    AccountClient,
    AppStoreInfoModel,
    Category,
    ICategory,
    InternalTag,
    IInternalTag,
    AccountOrderDataSumResponse,
    StartTrialResponseModel,
    AsorderDetail,
    OrderResult
} from "./../api/DixApiClient";
import {HistoryItemPeriod, historyPeriods} from "../interfaces/historyItem";
// tslint:disable-next-line: ordered-imports
import {StockSeriesType} from "../components/achart/achart.annotation.tools";
import {ChartDisplayMode} from "../enums/ChartDisplayMode.list";
import {IIndicatorsConfig, IIndicatorInstances} from "../components/achart/indicators";
import {darkTheme} from "../components/achart/anychart.dakrk.theme";
import {ChartColorTable} from "../components/achart/achart.colors";
import {BoxQuotaData, allowedForexSymbols} from "./box.quote.data";
import {ChartDisplayModeService} from "../services/layoutDisplayModeService/layoutDisplayModeService.service";
import {GlobalGridModeService} from "../services/globalGridMode/globalGridMode.service";
import {IChartConfig} from "../interfaces/IChartConfig";
import {ChartConfig} from "./ChartConfig";
import {IUserIndicators} from "../interfaces/IUserIndicators";
import {
    ISymbolInfo,
    IServiceResponse,
    LoginRs,
    SettingsRs,
    ISymbolOneClick
} from "../interfaces/service.response";
import {IBasket} from "../interfaces/IBasket";
import {QuoteTabsActiveModeService} from "../services/quoteTabsActiveMode/quoteTabsActiveMode.service";
import {SymbolTypeService} from "../services/quoteFilterTabsActiveMode/quoteFilterTabsActiveMode.service";
import {ISymbolBase} from "../interfaces/ISymbolBase";
import {DataService, initRequest} from "../services/data/data.service";
import {SymbolTypeEnum} from '../enums/SymbolType.enum';
import {QuotePanelsTabsList} from "../enums/QuotePanelsTabs.list";
import {ChartButtonsVisibleService} from "../services/ChartButtonsVisible.service";
import {ShowChartTooltipService} from "../services/ShoChartTooltip.service";
import {callNextAsync} from "../services/BaseService";
import {getPipBySymbol} from "../interfaces/quote.data";
import {IParameters} from "../interfaces/IParameters";
import {IdisplayModeForChartDisplayMode} from "../interfaces/displayModeForChartDisplayMode";
import {ChartLayoutModeService} from "../services/chartLayoutMode/chartLayoutMode.service";
import {IDemoUser} from "../interfaces/IDemoUsers";
import {ApplicationRef, ElementRef} from "@angular/core";
import {socialMedia} from "./socialMedia.request";
import {SaveSettingRequest} from "./save-setting.request.data";
import {Subject} from "rxjs";
import {AccountWS} from "./account.data";
import { Setting, Tournament, TournamentAssets, Product, ProductProperties, HomeClient, Adveristment } from '../api/DixApiClient';
import * as MobileDetect from "mobile-detect";
import * as moment from "moment";
import {ICompetitionData} from "../interfaces/IcompetitionData";
import {Alert} from "./alert";
import {TutorialVideoWindowComponent} from "../components/tutorial-video-window/tutorial-video-window.component";
import {UserType} from "../enums/USerType.enum";
import {IVersionInformation} from "./version";
import {HttpClient} from "@angular/common/http";
import {MobileMainView} from "../enums/mobile-mainViews";
import {challengeTabsList} from "../components/challenges/challenge.tab.list";
import {NgbDateStruct, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {tradeDeskTabsList} from "../components/tradedeskTabs/tradedeskTabs.list";
import {RoutingService, RouteParam, RouteParamValue} from "../services/routing.service";
import {
    ScannerPrimarySearchList,
    ScannerSide,
    ScannerChartingStudy
} from "../components/scanner/interfaces/scanner.enums";
import {quoteFilterTabsList} from "../components/quoteFilterTabs/quoteFilterTabs.list";
//import { dateFilterTypes } from '../components/date-selector/date-selector.component';
import {MoneyLine} from "../interfaces/service.response";
import {filter, find} from "rxjs/operators";
import {CookiesService} from "../tools/cookies.service";
import {LoginRequestModel} from "./login.request.data";
import {TradeRequestModel} from "./trade.request.data";
import {ISavedScan, IScannerProductAccess, ISavedScansOnePool, ScanHistory} from "../components/scanner/interfaces/scanner.interfaces";
import {storeCategories, flatTagMenu, IAppStoreProduct} from "../components/appstore/interfaces/appstore-interfaces";
import {SK} from "../interfaces/timeZones";
import {showScannerTrialReminderModal} from "../components/scanner/modals/ScannerTrialReminder/show-ScannerTrialReminder-modal";
import {AppStoreClientEx} from "../api/AppStoreClientEx";
import {ScannerBaseComponentComponent} from "../components/scanner/ScannerBaseComponent";
import {showScannerAutoTrialModal} from "../components/scanner/modals/ScannerAutoTrial/show-ScannerAutoTrial-modal";
import {landingClickState} from "../components/landingPage/landingPage.component";
import {LandingPageClickStateService} from "../services/landingPageClickStateService/landingPageClickState.service";
import {ThrowStmt} from "@angular/compiler";
import {AChartComponent} from "../components/achart/achart.component";
import {Providers} from "../enums/providers";
import {HomeComponent} from '../components/home/home.component';
import {LogOnInternalRs} from "../services/GAIN/gainlogonresp";


export class Workspace {
    private _chartDisplayMode: ChartDisplayMode = ChartDisplayMode.WIZARD;
    public specialToken: string = "";
    public challangeToken: string = "";

    public historyPips:number = 0;
    public historyPNL:number = 0;
    
    public get debugVisibility(): boolean {
        return this.dataService.DebugVisibility;
    }

    get activeTutorialVideo() {
        return this._activeTutorialVideo;
    }

    set activeTutorialVideo(v) {
        if(this.tutorialVideoWindow) this.tutorialVideoWindow.activeVideo = v;
        this._activeTutorialVideo = v;
    }

    get tutorialPanelShown() {
        return this._tutorialPanelShown;
    }

    set tutorialPanelShown(v) {
        if(this.tutorialPanel) this.tutorialPanel.shown = v;
        this._tutorialPanelShown = v;
    }

    _activeTutorialVideo: string | null = null;
    _tutorialPanelShown: boolean = false;
    tutorialVideoWindow?: TutorialVideoWindowComponent;
    tutorialPanel?: TutorialPanelComponent;
    watchedVideos: string[] = [];
    userTemplates: ITemplate[] = [];

    private _loggedIn: boolean = false;

    public get loggedIn(): boolean {
        return this._loggedIn;
    }
    public set loggedIn(value: boolean) {
        this._loggedIn = value;
    }

    private _applicationUserType: UserType = UserType.Regular;

    public get applicationUserType(): UserType {
        return this._applicationUserType;
    }

    public set applicationUserType(value: UserType) {
        this._applicationUserType = value;
    }

    public get chartDisplayMode(): ChartDisplayMode {
        return this._chartDisplayMode || (this.chartDisplayMode = ChartDisplayMode.WIZARD);
    }
    public set chartDisplayMode(v: ChartDisplayMode) {
        this.setHasChanges(this._chartDisplayMode == v, () => {
            this._chartDisplayMode =
                (this.routingService.setParam(RouteParam.ChartDisplayMode, v) as ChartDisplayMode) ||
                ChartDisplayMode.WIZARD;
            this.setChangedProperty("workspace-displayMode", true);
            this.setChangedProperty("chartDisplayMode", true);
            callNextAsync(this.chartDisplayModeService.subscriber, v).then(() => {
                callNextAsync(
                    this.activeLayoutTypeService.subscriber,
                    this.displayModeForChartDisplayMode[this.chartDisplayMode]
                );
            });
        });
    }




    public get layoutMode(): string {
        return this.displayModeForChartDisplayMode[this.chartDisplayMode];
    }
    public set layoutMode(v: string) {
        if(v != "" && v[0] == "4") {
            v = "4";
        }
        this.setHasChanges(this.displayModeForChartDisplayMode[this.chartDisplayMode] == v, () => {
            this.prevLayoutMode = this.displayModeForChartDisplayMode[this.chartDisplayMode];
            this.displayModeForChartDisplayMode[this.chartDisplayMode] = v;
            callNextAsync(
                this.activeLayoutTypeService.subscriber,
                this.displayModeForChartDisplayMode[this.chartDisplayMode]
            );
        });
    }

    private _mobileMode: string = "desktop";
    public get mobileMode(): string {
        return this._mobileMode;
    }
    public set mobileMode(value: string) {
        this._mobileMode = value;
    }

    public get horizontalMode() {
        return window.innerWidth > window.innerHeight;
    }

    public get prevLayoutMode(): string {
        return this.prevDisplayModeForChartDisplayMode[this.chartDisplayMode];
    }
    public set prevLayoutMode(v: string) {
        this.setHasChanges(this.displayModeForChartDisplayMode[this.chartDisplayMode] == v, () => {
            this.prevDisplayModeForChartDisplayMode[this.chartDisplayMode] = v;
        });
    }

    private _baskets: IBasket[] = [{items: []}, {items: []}, {items: []}, {items: []}, {items: []}];
    public get Baskets() {
        return this._baskets;
    }
    private _activeBasket: number = -1;
    public set activeBasket(v: number) {
        this.setHasChanges(this._activeBasket == v, () => {
            this._activeBasket = v;
            this.setChangedProperty("activeBasket", true);
            this.emitBasketChange(v);
        });
    }

    public get activeBasket() {
        return this._activeBasket;
    }

    public alertsAccess = false;
    public alerts: Alert[] = [];
    public alertStateEntries: AlertStateEntry[] = [];
    public activeAlertId = -1;
    public openedAlertId = -1;
    //public accounts: AccountWS[] = [];
    private _accounts: Account[] = [];

    private _afterChallengeUsers: (number | null | undefined)[] = [];
    public get afterChallengeUsers(): (number | null | undefined)[] {
        return this._afterChallengeUsers;
    }
    public set afterChallengeUsers(value: (number | null | undefined)[]) {
        this._afterChallengeUsers = value;
    }

    private _allAccount: Account[] = [];
    public get allAccount(): Account[] {
        return this._allAccount;
    }
    public set allAccount(value: Account[]) {
        this._allAccount = value;
    }

    public get accounts(): (Account | AccountProvider)[] {
        if(this.afterChallengeUsers.length > 0) {
            return this._accounts.filter(v => {
                return this.afterChallengeUsers.indexOf(v.id) == -1;
            });
        }

        return this._accounts;
    }


    public get accountIdForProvider() {

        let account = (this.accounts as AccountProvider[]).filter(v => {
            return v.id == this.activeAccountId
        })[0]

        if(account != undefined) {
            return account.accountProviderId;
        }
        else {
            return "";
        }

    }

    connectedState = true;

    connectionLostTimer = 0;


    public set accounts(value: (Account | AccountProvider)[]) {
        this._accounts = value;
    }

    private _providerWithoutAccounts: boolean = false;
    public get providerWithoutAccounts(): boolean {
        return this._providerWithoutAccounts;
    }
    public set providerWithoutAccounts(value: boolean) {
        this._providerWithoutAccounts = value;
    }

    public activeAccountId = -1;

    private _activeAccountIdBySet = -1;

    public get activeAccountIdBySet() {
        return this._activeAccountIdBySet;
    }
    public set activeAccountIdBySet(v: number) {
        let c = this.accounts.map(l => {
            return l.id;
        });

        if(c.indexOf(v) == -1) {
            v = c[0];
        }

        this.setHasChanges(this._activeAccountIdBySet == v, () => {
            this._activeAccountIdBySet = v;

            callNextAsync(this.globaGridMode.activeAccountIdBySetSubscriber, v);
        });
    }

    public get allowPendingOrders() {
        return this.dataService.AllowPendingOrders;
    }

    private _lineThickness: number = 2;
    public get lineThickness(): number {
        return this._lineThickness;
    }
    public set lineThickness(v: number) {
        // this._lineThickness = v;
        this.setHasChanges(this._lineThickness == v, () => {
            this._lineThickness = v;
        });
    }


    private _fillColor: string = "White";
    public get fillColor(): string {
        return this._fillColor;
    }
    public set fillColor(v: string) {
       
        
        this.setHasChanges(this._fillColor == v, () => {
            this._fillColor = v;
        });
    }

    private _strokeColor: string = "White";
    public get strokeColor(): string {
        return this._strokeColor;
    }
    public set strokeColor(v: string) {
     
        this.setHasChanges(this._strokeColor == v, () => {
            this._strokeColor = v;
        });
    }


    private _showQuotePanel: boolean = true;
    public get showQuotePanel(): boolean {
        return this._showQuotePanel;
    }
    public set showQuotePanel(v: boolean) {
        this.setHasChanges(this._showQuotePanel == v, () => {
            this._showQuotePanel = v;
        });
    }

    private _showTradeDesk: boolean = false;
    public get showTradeDesk(): boolean {
        return this._showTradeDesk;
    }
    public set showTradeDesk(v: boolean) {
        this.setHasChanges(this._showTradeDesk == v, () => {
            this._showTradeDesk = v;
        });
    //   this.globaGridMode.chartPreloaderHide.next(true)
    }

    private _showPeriod: boolean = false;
    public get showPeriod(): boolean {
        return this._showPeriod;
    }
    public set showPeriod(v: boolean) {
        this.setHasChanges(this._showPeriod == v, () => {
            this.globaGridMode.emitShowGrid(v);
            this._showPeriod = v;
        });
    }

    private _showCurrentRate: boolean = true;
    public get showCurrentRate(): boolean {
        return this._showCurrentRate;
    }
    public set showCurrentRate(v: boolean) {
        this.setHasChanges(this._showCurrentRate == v, () => {
            this._showCurrentRate = v;
            this.globaGridMode.showPriceIndicatorSubscriber.next(v);
        });
    }

    private _landingPageClickState: landingClickState = {
        panel: QuotePanelsTabsList.SYMBOL,
        showPanel: true,
        activeMobileView: MobileMainView.PANEL
    }
    public get landingPageClickState(): landingClickState {
        return this._landingPageClickState;
    }

    public set landingPageClickState(state: landingClickState) {
        this._landingPageClickState = state;
        callNextAsync(this.landingPageClickStateService.subscriber, state);

        console.log('set from settings');
    }

    private _showtradeLines: boolean = true;
    public get showtradeLines(): boolean {
        return this._showtradeLines;
    }
    public set showtradeLines(v: boolean) {
        this.setHasChanges(this._showtradeLines == v, () => {
            this._showtradeLines = v;
            callNextAsync(this.globaGridMode.showtradeLinesSubscriber, v);
            //this.globaGridMode.showtradeLinesSubscriber.next(v);
        });
    }

    private _showIndicatorLines: boolean = false;
    public get showIndicatorLines(): boolean {
        return this._showIndicatorLines;
    }
    public set showIndicatorLines(v: boolean) {
        this.setHasChanges(this._showIndicatorLines == v, () => {
            this._showIndicatorLines = v;
            this.globaGridMode.showIndicatorLinesSubscriber.next(v);
        });
    }

    private _lockAllCharts: boolean = true;
    public get lockAllCharts(): boolean {
        return this._lockAllCharts;
    }
    public set lockAllCharts(v: boolean) {
        this.setHasChanges(this._lockAllCharts == v, () => {
            this.globaGridMode.lockAllCharsSubscriber.next(v);
            this._lockAllCharts = v;
        });
    }

    private _quoteDisplayMode: number = 1;
    public get quoteDisplayMode(): number {
        return this._quoteDisplayMode;
    }
    public set quoteDisplayMode(v: number) {
        this.setHasChanges(this._quoteDisplayMode == v, () => {
            this._quoteDisplayMode = v;
        });
    }

    indicators?: IIndicatorsConfig;

    public charts: {[key: string]: ChartConfig} = {};

    userIndicators: {[key: string]: IUserIndicators} = {};
    userSets: {[key: string]: string} = {};

    demoUserList: IDemoUser[] = [];

    //public setChanged = new Subject<string | null>();

    private _selectedSet: string | null = null;
    public get selectedSet(): string | null {
        if(this.mobileMode != "desktop") {
            //  debugger
            return this.mobileSetId;
        }

        return this._selectedSet;
    }
    public set selectedSet(value: string | null) {
        if(value == this._selectedSet) return;
        this._selectedSet = value;
        sessionStorage.setItem("selectedSet", value || "");
        //  localStorage.setItem("selectedSet", value || "");
        //this.setChanged.next(value);
    }

    private _boxes: BoxQuotaData[] = [];
    public get boxes(): BoxQuotaData[] {
        this._boxes = this._boxes || [];

        // if(this._boxes.length>0)
        // {
        //     let filtered = this._boxes.filter(v=>{

        //         if(v.Type=="forex")
        //         {
        //              return v;
        //         }

        //     }).splice(0,3);

        //     return filtered;
        // }

        return this._boxes;
    }
    public set boxes(value: BoxQuotaData[]) {
        this._boxes = value;
    }

    public sumOfPips: string = "";

    // public sumOfUplUsd: string = "";

    public balance: string = "";

    public marginInUse: string = "";

    private _activeTab: QuotePanelsTabsList = QuotePanelsTabsList.SYMBOL;
    public get activeTab(): QuotePanelsTabsList {
        return this._activeTab;
    }

    public wasScanResultsView: boolean = false;

    public set activeTab(tabId: QuotePanelsTabsList) {
        this.setHasChanges(this._activeTab == tabId, () => {
            this._activeTab = this.routingService.setParam(RouteParam.PanelTab, tabId) as QuotePanelsTabsList;
            callNextAsync(this.quoteTabsActiveModeService.subscriber, this._activeTab);
            this.emitBasketChange(this.activeBasket);

            if(this.activeTab == QuotePanelsTabsList.SCANNER) {
                if(this.wasScanResultsView) {
                    this.showBackToResults = true;
                    this.wasScanResultsView = false;
                    this.showScannerPage = false;
                } else {
                    this.showScannerPage = true;
                    this.showAppStore = false;
                }



            } else {
                this.showScannerPage = false;
                this.showAppStore = false;
                if(this.showBackToResults) {
                    this.showBackToResults = false;
                    this.wasScanResultsView = true;
                }
            }
        });
    }

    private _activeSymbolType: SymbolTypeEnum = SymbolTypeEnum.Forex;
    get activeSymbolType(): SymbolTypeEnum {
        return this._activeSymbolType;
    }

    set activeSymbolType(tabId: SymbolTypeEnum) {
        this.setHasChanges(this._activeSymbolType == tabId, () => {
            this._activeSymbolType = this.routingService.setParam(RouteParam.SymbolType, tabId) as SymbolTypeEnum;
            callNextAsync(this.symbolTypeService.subscriber, tabId);
        });
    }

    private _tradeDeskHeight: number = 400;

    public get tradeDeskHeight(): number {
        return this._tradeDeskHeight;
    }

    public set tradeDeskHeight(value: number) {
        this.setHasChanges(this._tradeDeskHeight == value, () => {
            this._tradeDeskHeight = value;
            //     callNextAsync(this.symbolTypeService.subscriber, value);
        });
    }

    private _lastTradeInformations: string = "";
    public get lastTradeInformations(): string {
        return this._lastTradeInformations;
    }
    public set lastTradeInformations(value: string) {
        this.setHasChanges(this._lastTradeInformations == value, () => {
            this._lastTradeInformations = value;
            //     callNextAsync(this.symbolTypeService.subscriber, value);
        });
    }

    private _orderGridColumnsState: string = "";

    public get orderGridColumnsState(): string {
        return this._orderGridColumnsState;
    }

    public set orderGridColumnsState(value: string) {
        this.setHasChanges(this._orderGridColumnsState == value, () => {
            this._orderGridColumnsState = value;
            callNextAsync(this.globaGridMode.sendOrderGridChange, value);
        });
    }

    private _historyGridColumnsState: string = "";

    public get historyGridColumnsState(): string {
        return this._historyGridColumnsState;
    }

    public set historyGridColumnsState(value: string) {
        this.setHasChanges(this._orderGridColumnsState == value, () => {
            this._historyGridColumnsState = value;
            callNextAsync(this.globaGridMode.sendHistoryOrderGridChange, value);
        });
    }

    private _lockTradeDesk: boolean = false;

    public get lockTradeDesk(): boolean {
        return this._lockTradeDesk;
    }

    public set lockTradeDesk(value: boolean) {
        this.setHasChanges(this._lockTradeDesk == value, () => {
            this._lockTradeDesk = value;
            //  callNextAsync(this.globaGridMode.sendHistoryOrderGridChange, value);
        });
    }

    public loadedSymbolsTypeSplit: ISymbolBase = {
        forex: [],
        crypto: [],
        equity: [],
        commodity: [],
        index: [],
        bonds: []
    };
    public SymbolInfoes: ISymbolInfo[] = [];

    public SymbolOneClicks: {[symbol: string]: ISymbolOneClick} = {};

    public Version: IVersionInformation = {};


    public appSettings: any;

    constructor(
        protected app: ApplicationRef,
        public chartDisplayModeService: ChartDisplayModeService,
        public globaGridMode: GlobalGridModeService,
        public quoteTabsActiveModeService: QuoteTabsActiveModeService,
        private symbolTypeService: SymbolTypeService,
        private dataService: DataService,
        public chartButtonsVisibleService: ChartButtonsVisibleService,
        public showChartTooltipService: ShowChartTooltipService,
        private activeLayoutTypeService: ChartLayoutModeService,
        public landingPageClickStateService: LandingPageClickStateService,
        private settingsClient: SettingsClient,
        private tournamentClient: TournamentClient,
        private homeClient: HomeClient,
        public AccountsClient: AccountsClient,
        private http: HttpClient,
        public routingService: RoutingService,
        public cookieService: CookiesService,
        public appStoreClient: AppStoreClientEx,
        public AccountClient: AccountClient,
    ) {
        this.appSettings=JSON.parse((<any>window).appSettings);
        
        this.tryToGetUserDataFromStore();

        let mobileDevice = new MobileDetect(window.navigator.userAgent);
        routingService.onParamChanged.subscribe(paramChangedEvent => {
            switch(paramChangedEvent.param) {
                case RouteParam.ChartDisplayMode:
                    this.chartDisplayMode =
                        this.getRouterDisplayMode(paramChangedEvent.newValue) || this.chartDisplayMode;
                    break;
                case RouteParam.PanelTab:
                    this.activeTab = this.getRouterActiveTab(paramChangedEvent.newValue) || this.activeTab;
                    break;
                case RouteParam.SymbolType:
                    this.activeSymbolType =
                        this.getRouterSymbolType(paramChangedEvent.newValue) || this.activeSymbolType;
                    break;
            }
        });

        if(mobileDevice.phone() !== null) {
            this.mobileMode = "phone";
        }

        if(mobileDevice.tablet() !== null) {
            this.mobileMode = "phone";
        }

        this.initBoxQuotes();
        this.initChartsDefault();
        this.subscribeDataService();

        this.socialMedia.Init();
        // this.setChanged.subscribe(newSet => {
        //     this.load();
        // });
        this.loadVersionInformation();
        this.subscribeForLoginResponse();
        this.resetConnectionLostTimer();
        this.dataService.dataSubscriber.subscribe(response => {
            this.resetConnectionLostTimer();
        });
    }


    resetConnectionLostTimer() {
        this.connectedState = true;
        if(this.connectionLostTimer != 0)
            clearTimeout(this.connectionLostTimer);

        this.connectionLostTimer = setTimeout(() => this.connectedState = false, 60 * 1000) as any as number;
    }

    tryToGetUserDataFromStore() {
        if(this.cookieService.getCookie("_r") !== undefined) {
            let t = this.cookieService.getCookie("_r");
            let u = this.cookieService.getCookie("_xu");
            let p = this.cookieService.getCookie("_zp");
            let pr = this.cookieService.getCookie("_provider");
            if(t == "1") {
                this.remember = true;
                this.userName = atob(u);
                this.userPassword = atob(p);
                this.loginProvider = (pr != "") ? pr : "DEMO";
            } else {
                this.remember = false;
            }
        }
    }

    private _loginProvider: string = "DEMO";
    public get loginProvider(): string {
        return this._loginProvider;
    }
    public set loginProvider(value: string) {
        this._loginProvider = value;
    }
    getRouterDisplayMode(paramValue?: RouteParamValue): ChartDisplayMode | undefined {
        if(paramValue == undefined) paramValue = this.routingService.getParam(RouteParam.ChartDisplayMode);
        if(paramValue == undefined) return undefined;

        if((Object as any).values(ChartDisplayMode).indexOf(paramValue) !== -1) return paramValue as ChartDisplayMode;

        return undefined;
    }

    getRouterActiveTab(paramValue?: RouteParamValue): QuotePanelsTabsList | undefined {
        if(paramValue == undefined) paramValue = this.routingService.getParam(RouteParam.PanelTab);
        if(paramValue == undefined) return undefined;

        if((Object as any).values(QuotePanelsTabsList).indexOf(paramValue) !== -1)
            return paramValue as QuotePanelsTabsList;

        return undefined;
    }

    getRouterSymbolType(paramValue?: RouteParamValue): SymbolTypeEnum | undefined {
        if(paramValue == undefined) paramValue = this.routingService.getParam(RouteParam.SymbolType);
        if(paramValue == undefined) return undefined;

        if((Object as any).values(SymbolTypeEnum).indexOf(paramValue) !== -1) return paramValue as SymbolTypeEnum;

        return undefined;
    }

    private loadVersionInformation() {
        this.http.get("version.json").subscribe((v: IVersionInformation) => {
            this.Version = v;
        });
    }

    private _buildNumber: string | undefined = "x";
    public get buildNumber(): string | undefined {
        return this.Version["Build.BuildNumber"];
    }

    addWatchedVideo(wistiaVideoId: string) {
        this.setHasChanges(this.watchedVideos.indexOf(wistiaVideoId) != -1, () => {
            this.watchedVideos.push(wistiaVideoId);
            this.setChangedProperty("watchedVideos", true);
            this.save();
        });
    }

    addUserTemplate(template: ITemplate) {
        this.setHasChanges(false, () => {
            this.userTemplates.push(template);
            this.setChangedProperty("userTemplates", true);
            this.save();
        });
        return template;
    }

    replaceUserTemplate(oldTemplate: ITemplate, newTemplate: ITemplate) {
        const index = this.userTemplates.indexOf(oldTemplate);
        const templateExists = index != -1;
        this.setHasChanges(!templateExists, () => {
            this.userTemplates.splice(index, 1, newTemplate);
            this.setChangedProperty("userTemplates", true);
            this.save();
        });
        return templateExists;
    }

    removeUserTemplate(template: ITemplate) {
        const index = this.userTemplates.indexOf(template);
        const templateExists = index != -1;
        this.setHasChanges(!templateExists, () => {
            this.userTemplates.splice(index, 1);
            this.setChangedProperty("userTemplates", true);
            this.save();
        });
        return templateExists;
    }

    public getAlertState(alert: Alert): AlertState {
        if(this.alertStateEntries == null) return AlertState.Unread;

        const alertStateEntry = this.alertStateEntries.find(ase => ase.AlertId == alert.Id);
        if(alertStateEntry == null) return AlertState.Unread;

        return alertStateEntry.State;
    }

    public setAlertState(alert: Alert, state: AlertState) {
        this.dataService.sendRequest({
            Cmd: DataService.TYPE_SETALERTSTATE,
            Data: {AlertId: alert.Id, State: state}
        });
    }

    private subscribeDataService() {
        this.dataService.dataSubscriber.subscribe(response => {
            if(this.loggedIn) {
                const responseAny = response as any;
                switch(response.Type) {
                    case "LoginRs":
                        //   this.LoginRsResponse(<LoginRs>response);
                        break;
                    case "CreateAccountRs":
                        if(responseAny.ErrorMessage == null) this.accounts.push(responseAny.Account);
                        break;
                    case "RefreshProductsRs":

                        this.appStoreData(responseAny.OrderId);
                        break;
                    case "DeleteAccountRs":
                        if(responseAny.ErrorMessage == null)
                            this.accounts = this.accounts.filter(a => a.id != responseAny.Account.Id);
                        break;
                    case "RenameAccountRs":
                        if(responseAny.ErrorMessage == null) {
                            const account = this.accounts.find(a => a.id == responseAny.Account.Id);
                            if(account != null) account.accountName = responseAny.Account.AccountName;
                        }
                        break;
                    case "SwitchAccountRs":
                        if(responseAny.ErrorMessage == null) {
                            this.activeAccountId = responseAny.ActiveAccount.Id;
                        }
                        break;
                    case "NewAlert":
                        const newAlert = response as NewAlert;
                        this.alerts.push(newAlert.Alert);
                        break;
                    case "AlertStateChanged":
                        const alertStateChanged = response as AlertStateChanged;
                        const localAlertStateEntry = this.alertStateEntries.find(
                            ase => ase.Id == alertStateChanged.AlertStateEntry.Id
                        );
                        if(localAlertStateEntry != null)
                            localAlertStateEntry.State = alertStateChanged.AlertStateEntry.State;
                        else this.alertStateEntries.push(alertStateChanged.AlertStateEntry);
                        break;
                }
                // this.updateSymbolTicks(response);
            }

            this.updateSymbolTicks(response);
        });
    }

    public initOrderSymbol: string[] = [];
    private initBoxQuotes() {
        
        (initRequest.initOrder || []).forEach(v => {
            var bd: BoxQuotaData = new BoxQuotaData(this);
            bd.Symbol = v;
            bd.Bid = -1;
            bd.Ask = -1;
        //    bd.Pip = getPipBySymbol(v);
            bd.Type = SymbolTypeEnum.Forex; // this.getSymbolInfoByName(v).Type
            this.boxes.push(bd);
        });
        this.boxes.sort((a, b) => (a.Symbol < b.Symbol ? -1 : a.Symbol > b.Symbol ? 1 : 0));

        /**Firefox FIX */
        this.boxes.forEach(v => {
            this.initOrderSymbol.push(v.Symbol);
        });
    }

    private initChartsDefault() {
        if(this.mobileMode != "desktop") {
            Object.keys(this._defaultChartsMobile).forEach(chartId => {
                var cfg: IChartConfig = this._defaultChartsMobile[chartId];
                this.charts[chartId] = new ChartConfig(this, cfg);
            });
        } else {
            Object.keys(this._defaultCharts).forEach(chartId => {
                var cfg: IChartConfig = this._defaultCharts[chartId];
                this.charts[chartId] = new ChartConfig(this, cfg);
            });
        }
    }

    private _isFirstLogin: boolean = false;
    public get isFirstLogin(): boolean {
        return this._isFirstLogin;
    }
    public set isFirstLogin(value: boolean) {
        this._isFirstLogin = value;
    }



    private _addPointsForWzard: boolean = true;
    public get addPointsForWzard(): boolean {
        return this._addPointsForWzard;
    }
    public set addPointsForWzard(value: boolean) {
        this._addPointsForWzard = value;
    }

    private _isTrialExpired: boolean = false;
    public get isTrialExpired(): boolean {
        return this._isTrialExpired;
    }
    public set isTrialExpired(value: boolean) {
        this._isTrialExpired = value;
    }


    private _allowScannerAccess: boolean = false;
    public get allowScannerAccess(): boolean {

        let now = moment().utc();
        if(this.currentServerTime) {
            now = this.currentServerTime.utc();
        }

        if(this.trialDateRanges) {

            if(this.trialDateRanges.from && this.trialDateRanges.to) {
                if(now.isBetween(this.trialDateRanges.from, this.trialDateRanges.to, "days", "[)")) {
                    return true;
                }
            }

            if(this.trialDateRanges.from && this.trialDateRanges.to) {
                if(now.isAfter(this.trialDateRanges.to) || now.isSame(this.trialDateRanges.to)) {
                    this.isTrialExpired = true
                    if(this.hasSomeProduct) {
                        return true;
                    }
                    return false;
                }
            }
        }

        return this.hasSomeProduct;// this._allowScannerAccess;
    }








    public set allowScannerAccess(value: boolean) {
        this._allowScannerAccess = value;
    }

    /**TRIAL SCANNER */
    private _allowScannerTrial: boolean = false;
    public get allowScannerTrial(): boolean {

        return this.trialDateRanges == undefined;

        return this._allowScannerTrial;
    }

    public set allowScannerTrial(value: boolean) {
        this._allowScannerTrial = value;
    }

    private _trialDateRanges?: {
        from: moment.Moment | null | undefined;
        to: moment.Moment | null | undefined;
    };


    public startTrial(productId: number, userId: number): Promise<StartTrialResponseModel | null> {
        return new Promise<StartTrialResponseModel | null>((rs, rj) => {
            this.appStoreClient
                .startTrial(productId, userId)
                .toPromise()
                .then(s => {
                    rs(s);
                })
                .catch(error => {
                    rj(error);
                });
        });
    }


    public createOrUpdateOrder(sessionKey?: string | null | undefined, userId?: number | undefined, sku?: string | null | undefined, chekaoutId?: string | null | undefined, checkoutUrl?: string | null | undefined, checkoutData?: string | null | undefined, orderId?: number | null | undefined): Promise<OrderResult | null> {
        return new Promise<OrderResult | null>((rs, rj) => {
            this.appStoreClient
                .createOrUpdateOrderEx(sessionKey, userId, sku, chekaoutId, checkoutUrl, checkoutData)
                .toPromise()
                .then(s => {
                    //    debugger;
                    rs(s);
                })
                .catch(error => {
                    //     debugger;
                    rj(error);
                });
        });
    }


    public getRating(productId: number): Promise<number> {
        return new Promise<number>((rs, rj) => {
            this.appStoreClient
                .getRating(productId)
                .toPromise()
                .then(s => {
                    rs(s);
                })
                .catch(error => {
                    rj(error);
                });
        });
    }

    public getRatingsCount(productId: number): Promise<number> {
        return new Promise<number>((rs, rj) => {
            this.appStoreClient
                .getRatingsCount(productId)
                .toPromise()
                .then(s => {
                    rs(s);
                })
                .catch(error => {
                    rj(error);
                });
        });
    }

    public addRating(userId: number, productId: number, rate: number): Promise<boolean> {
        return new Promise<boolean>((rs, rj) => {
            this.appStoreClient
                .addRating(userId, productId, rate)
                .toPromise()
                .then(s => {
                    rs(s);
                })
                .catch(error => {
                    rj(error);
                });
        });
    }

    public checkUserRating(userId: number, productId: number): Promise<number> {
        return new Promise<number>((rs, rj) => {
            this.appStoreClient
                .checkUserSetRating(productId, userId)
                .toPromise()
                .then(s => {
                    rs(s);
                })
                .catch(error => {
                    rj(error);
                });
        });
    }

    public currentServerTime?: moment.Moment;
    public getUserActiveProducts(userId: number): Promise<AsorderDetail[] | null> {
        return new Promise<AsorderDetail[] | null>((rs, rj) => {
            this.appStoreClient
                .getUserActiveProducts(userId)
                .toPromise()
                .then(s => {
                    this.currentServerTime = s.currentTime;
                    rs(s.products);
                })
                .catch(error => {
                    rj(error);
                });
        });
    }

    private _scannerTrialSku: string = "scanner-trial";
    public get scannerTrialSku(): string {
        return this._scannerTrialSku;
    }
    public set scannerTrialSku(value: string) {
        this._scannerTrialSku = value;
    }

    public activateTrial() {

        this.startTrial(this.scannerProductId, this.userId).then(response => {


            console.log("this.startTrial");
            console.log(response);

            if(response) {
                if(response.orderDetail) {

                    if(this.autoTrialAction) {
                        this.globaGridMode.registrationScanner.next(true);
                        this.autoTrialAction = false;
                    }
                    else {
                        this.globaGridMode.scannerTrialLauncher.next(true);
                    }

                }

                this.appStoreData();
            }




        })

    }

    private _autoTrialAction: boolean = false;
    public get autoTrialAction(): boolean {
        return this._autoTrialAction;
    }
    public set autoTrialAction(value: boolean) {
        this._autoTrialAction = value;
    }

    public autoTrialRegistration() {
        this.activeTab = QuotePanelsTabsList.SCANNER;
        this.autoTrialAction = true;
    }


    public get trialDaysToEnd(): number {
        let now = moment().utc();
        if(this.currentServerTime) {
            now = this.currentServerTime//.utc();
        }




        if(this.trialDateRanges && this.trialDateRanges.to) {
            let daysNum = 1 + this.trialDateRanges.to.diff(now, "days");

            if(daysNum > 10) {
                daysNum = 10;
            }

            if(now.isSame(this.trialDateRanges.to, 'day')) {
                return 0;
            }





            return daysNum;
        }

        return -1000;
    }

    public get trialDateRanges():
        | {
            from: moment.Moment | null | undefined;
            to: moment.Moment | null | undefined;
        }
        | undefined {

        return this._trialDateRanges;
    }

    public set trialDateRanges(
        value:
            | {
                from: moment.Moment | null | undefined;
                to: moment.Moment | null | undefined;
            }
            | undefined
    ) {
        this._trialDateRanges = value;
    }

    /*scannerProducts*/

    private _storeCategories: ICategory[] = [];
    public get storeCategories(): ICategory[] {
        return this._storeCategories;
    }
    public set storeCategories(value: ICategory[]) {
        this._storeCategories = value;
    }

    public storeTagsMenu: IInternalTag[] = [
        {
            id: -1,
            name: "Home",
            //     internalTagId:-1,
            isActive: 1
        }
    ];

    private _productPricing: IAppStoreProduct[] = [
        // {productId:"1", image: "images/scanner/test-thumbs/gifs/Wizard-SCANNER-GIF.gif", description:"DESC", thumbnail:"images/scanner/test-thumbs/wizard.png", name:"Wizard", price: 9.95, access:true, categories:[1], tags:[1,2]},
        // {productId:"2", image: "images/scanner/test-thumbs/gifs/Charting-Gif.gif", description:"DESC",  thumbnail:"images/scanner/test-thumbs/charting.png", name:"Charting", price: 14.95, access:true, categories:[1], tags:[]},
        // {productId:"3", image: "images/scanner/test-thumbs/gifs/TI-Wizard-SCANNER-GIF.gif", description:"DESC",  thumbnail:"images/scanner/test-thumbs/ti-wizard.png", name:"TI Wizard", price: 7.95, access:true, categories:[1], tags:[2]},
        // {productId:"4", image: "images/scanner/test-thumbs/gifs/entry-signals-scan-product-gif.gif", description:"DESC",  thumbnail:"images/scanner/test-thumbs/entry-signals.png", name:"Entry Signals", price: 9.95, access:false, categories:[1], tags:[1]},
        // {productId:"5", description:"DESC",  thumbnail:"images/scanner/test-thumbs/allproducts.png", name:"All", price: 29.95, access:true, categories:[1], tags:[1]},
        // {productId:"6", description:"DESC",  thumbnail:"images/scanner/test-thumbs/level-2.png", name:"Level 2", price: 29.95, access:true, categories:[1], tags:[1]},
    ];


    public get producsList(): IAppStoreProduct[] {
        return this._productPricing;
    }
    public set producsList(value: IAppStoreProduct[]) {
        this._productPricing = value;
    }

    public getProductDataBySku(sku: string) {
        let filtered = this.producsList.filter(v => {
            return v.sku == sku;
        });

        if(filtered.length > 0) return filtered[0];

        return {price: -1};
    }


    public mapProductComponentsToSku: {sku?: any; component?: any, isActive?: boolean, IsTrial?: boolean, Expired?: boolean}[] = [
        {sku: "scanner-wizard", component: ScannerPrimarySearchList.SCANNER_WIZARD, isActive: false, IsTrial: false, Expired: false},
        {sku: "scanner-charting", component: ScannerPrimarySearchList.SCANNER_CHARTING, isActive: false, IsTrial: false, Expired: false},
        {sku: "scanner-tiwizard", component: ScannerPrimarySearchList.SCANNER_TIWIZARD, isActive: false, IsTrial: false, Expired: false},
        {sku: "scanner-entrysignals", component: ScannerPrimarySearchList.SCANNER_ENTRYSIGNALS, isActive: false, IsTrial: false, Expired: false},
        {sku: "scanner-level2", component: "activeNarrowScanner", isActive: false, IsTrial: false, Expired: false},
        {sku: "scanner-trial", component: "scannerTrial", isActive: false, IsTrial: false, Expired: false},
        {sku: "scanner-combo", component: "scannerAll", isActive: false, IsTrial: false, Expired: false},
        {sku: "test-wizard", component: "", isActive: false, IsTrial: false, Expired: false}
    ];

    public setProductActive(sku: string | null | undefined, state: boolean) {
        this.mapProductComponentsToSku.filter(v => {
            return v.sku == sku;
        })[0].isActive = state;

    }

    public setProductTrial(sku: string | null | undefined, state: boolean) {
        this.mapProductComponentsToSku.filter(v => {
            return v.sku == sku;
        })[0].IsTrial = state;

    }

    public setProductTrialExpired(sku: string | null | undefined, state: boolean) {
        this.mapProductComponentsToSku.filter(v => {
            return v.sku == sku;
        })[0].Expired = state;

    }


    public getProductActive(sku: string | null | undefined) {

        let product = this.mapProductComponentsToSku.filter(v => {
            return v.sku == sku;
        })

        if(product[0] != undefined) {

            return product[0].isActive;
        }
        else {
            return false;
        }
    }

    public getProductTrial(sku: string | null | undefined) {

        let product = this.mapProductComponentsToSku.filter(v => {
            return v.sku == sku;
        })

        if(product[0] != undefined) {

            return product[0].IsTrial;
        }
        else {
            return false;
        }
    }


    public checkAvaiabilityofComponent(component: any) {

        if(component == "NA") {
            return true;
        }


        let sku: string = this.mapProductComponentsToSku.find(v => v.component == component)!.sku;

        let product: IAppStoreProduct | undefined = this.producsList.find(v => v.sku == sku);

        if(product) {
            let availibility = product.access;
            return availibility;
        }

        return false;
    }


    public scannerProductId: number = -1;

    private _getScannerTrialProducts: (Product | null | undefined)[] = [];
    public get scannerTrialProducts(): (Product | null | undefined)[] {
        return this._getScannerTrialProducts;
    }
    public set scannerTrialProducts(value: (Product | null | undefined)[]) {
        this._getScannerTrialProducts = value;
    }


    private _lastPrId: string = "";
    public get lastPrId(): string {
        return this._lastPrId;
    }
    public set lastPrId(value: string) {
        this._lastPrId = value;
    }


    public activateProductById(productId: number, modal: any) {

        this.startTrial(productId, this.userId).then(response => {

            console.log("startProductTrial");
            console.log(response);

            if(response) {
                if(response.orderDetail) {

                    this.appStoreData(response.orderDetail[0].asorderId);
                    modal.close();
                    //  this.globaGridMode.appSuccessNotification.next(response.orderDetail[0].productId);
                }

            }


        })

    }

    private _wasScannerTrial: boolean = false;
    public get wasScannerTrial(): boolean {
        return this._wasScannerTrial;
    }
    public set wasScannerTrial(value: boolean) {
        this._wasScannerTrial = value;
    }
    public appStoreData(orderId?: number) {

        this.mapProductComponentsToSku.forEach(t => {
            t.isActive = false;
        })

        if(this.userId == 0) {
            return;
        }

        this.getAllAppStoreData().then(response => {
            if(response) {
                if(response.categories) {
                    this.storeCategories = [
                        {
                            id: -1,
                            name: "All"
                        }
                    ];

                    this.storeCategories = this.storeCategories.concat(response.categories);
                }

                if(response.tags) {
                    this.storeTagsMenu = [
                        {
                            id: -1,
                            name: "Home",
                            isActive: 1
                        }
                    ];
                    this.storeTagsMenu = this.storeTagsMenu.concat(response.tags);
                }

                if(response.products) this.appStoreProducts = response.products;


                // let getTrialProductInfo = this.appStoreProducts.filter(v=>{

                // })

                let scannerTrial = this.appStoreProducts.filter(v => {
                    return v.sku == "scanner-trial"
                })[0]

                this.scannerProductId = scannerTrial.id;

                if(this.autoTrialAction) {
                    this.activateTrial();
                }

                this.getUserActiveProducts(this.userId).then(response => {


                    console.log("trialActivate:" + this.userId + "");
                    console.log(response);
                    console.log(this.currentServerTime);

                    let scannerTrialInfo: AsorderDetail[] | null;
                    if(response) {
                        scannerTrialInfo = response.filter(v => {
                            return v.productId == this.scannerProductId
                        })


                        if(scannerTrialInfo.length > 0) {

                            this.wasScannerTrial = true;
                            if(scannerTrialInfo[0].startTime && scannerTrialInfo[0].endTime) {
                                console.log("TRIAL DATES");
                                console.log(scannerTrialInfo[0].startTime.format("YYYY-MM-DD"))
                                console.log(scannerTrialInfo[0].endTime.format("YYYY-MM-DD"))
                            }

                            this.trialDateRanges = {from: scannerTrialInfo[0].startTime/*!.utc()*/, to: scannerTrialInfo[0].endTime/*!.utc()*/}

                            if(scannerTrial.productToProductProduct)
                                this.scannerTrialProducts = scannerTrial.productToProductProduct.map(v => {
                                    return v.subProduct
                                })

                            let now = moment().utc();
                            if(this.currentServerTime) {
                                now = this.currentServerTime.utc();
                            }


                            if(this.trialDateRanges) {

                                if(this.trialDateRanges.from && this.trialDateRanges.to) {
                                    if(now.isBetween(this.trialDateRanges.from, this.trialDateRanges.to, "days", "[)")) {
                                        //  return true;
                                        this.scannerTrialProducts.forEach(v => {

                                            if(v) {
                                                this.setProductActive(v.sku, true);
                                                this.setProductTrial(v.sku, true);
                                            }
                                        })

                                    } else {
                                        this.setProductTrialExpired("scanner-trial", true);
                                    }
                                }
                            }

                            console.log(scannerTrialInfo);
                            console.log(this.trialDateRanges.from);
                        }

                        response.forEach(v => {
                            if(v.productId != this.scannerProductId) {

                                if(v.asorderId == orderId) {
                                    this.globaGridMode.appSuccessNotification.next(v.productId);
                                }


                                let product = this.appStoreProducts.filter(l => {
                                    return Number(l.id) == v.productId;
                                })[0]

                                this.setProductActive(product.sku, true);
                                //  this.setProductTrial(product.sku, true);

                                if(product.productToProductProduct) {


                                    let subproducts = product.productToProductProduct.map(l => {
                                        return l.subProduct
                                    })

                                    subproducts.forEach(k => {

                                        if(k) {
                                            this.setProductActive(k.sku, true);
                                            this.setProductTrial(k.sku, false);
                                        }
                                    })

                                }

                                this.hasSomeProduct = true;
                            }
                        })

                    }

                    this.producsList = this.appStoreProducts.map(product => {
                        return <IAppStoreProduct> {
                            name: product.name,

                            price: this.getCurrentPriceFromProperties(product.productProperties),

                            productId: product.id.toString(),
                            access: this.getProductActive(product.sku), // product.sku=="scanner-wizard" || product.sku=="scanner-level2"?true:false,
                            categories: product.productCategory
                                ? product.productCategory.map(l => {
                                    return l.categoryId;
                                })
                                : [],
                            tags: product.productInternalTag
                                ? product.productInternalTag.map(l => {
                                    return l.internalTagId;
                                })
                                : [],
                            thumbnail: product.smallImage,
                            image: product.regularImage,
                            description: product.description,
                            sku: product.sku,
                            IsTrial: this.getProductTrial(product.sku)
                        };
                    });


                });
            }
        })
    }




    private _hasSomeProduct: boolean = false;
    public get hasSomeProduct(): boolean {
        return this._hasSomeProduct;
    }
    public set hasSomeProduct(value: boolean) {
        this._hasSomeProduct = value;
    }



    public getCurrentPriceFromProperties(properties: ProductProperties[] | null | undefined) {
        let now = moment();

        if(properties) {
            let activeProductProperty = properties.filter(l => {
                if(l.stopDate == null) {
                    return true;
                }

                if(now.isBetween(l.startDate, l.stopDate, "days", "[]")) {
                    return true;
                }

                return true;
            });

            if(activeProductProperty.length > 0) {
                return activeProductProperty[0].regularPrice;
            }
        }

        return -1;
    }

    public getAllAppStoreData() {
        return new Promise<AppStoreInfoModel>((rs, rj) => {
            this.appStoreClient
                .getInfo()
                .toPromise()
                .then(s => {
                    rs(s);
                })
                .catch(error => {
                    rj(error);
                });
        });
    }


    private _showAppStore: boolean = false;
    public get showAppStore(): boolean {
        return this._showAppStore;
    }
    public set showAppStore(value: boolean) {
        this._showAppStore = value;
    }


    public showAppStoreAction() {
        this.appStoreData();
        this.showScannerPage = false;
        this.showLandingPage = false;
        this.showAppStore = true;
    }




    private _appStoreCategories: Category[] = [];
    public get appStoreCategories(): Category[] {
        return this._appStoreCategories;
    }
    public set appStoreCategories(value: Category[]) {
        this._appStoreCategories = value;
    }

    private _appStoreTags: InternalTag[] = [];
    public get appStoreTags(): InternalTag[] {
        return this._appStoreTags;
    }
    public set appStoreTags(value: InternalTag[]) {
        this._appStoreTags = value;
    }

    private _appStoreProducts: Product[] = [];
    public get appStoreProducts(): Product[] {
        return this._appStoreProducts;
    }
    public set appStoreProducts(value: Product[]) {
        this._appStoreProducts = value;
    }



    public get anyProductIsActive(): boolean {
        var res = false;
        this.mapProductComponentsToSku.forEach(x => res = res || (x.isActive == true));
        return res;
    }

    public get anyProductIsTrial(): boolean {
        var res = false;
        this.mapProductComponentsToSku.forEach(x => res = res || (x.IsTrial == true));
        return res;
    }

    public get IsScannerTrialExpired(): boolean {
        var res = false;
        //  this.mapProductComponentsToSku.forEach(x => res = (x.sku == "scanner-trial" && x.Expired == true));

        let trial = this.appStoreProducts.find(x => x.sku == "scanner-trial");

        if(trial != undefined) {
            //     if(trial.Expired || trial.isActive)
            res = true;
        }

        res = this.wasScannerTrial;
        return res;
    }


    /*end scannerProducts*/

    private _subscribeHref: string = "https://premieretrade.com/";
    public get subscribeHref(): string {
        return this._subscribeHref;
    }
    public set subscribeHref(value: string) {
        this._subscribeHref = value;
    }

    private _selectedPrimaryScanner: ScannerPrimarySearchList = ScannerPrimarySearchList.SCANNER_NA;
    public get selectedPrimaryScanner(): ScannerPrimarySearchList {
        return this._selectedPrimaryScanner;
    }

    private _isNarrowScanMode: boolean = false;
    public get isNarrowScanMode(): boolean {
        return this._isNarrowScanMode;
    }
    public set isNarrowScanMode(value: boolean) {
        this._isNarrowScanMode = value;
    }


    // protected modalService: NgbModal;

    public set selectedPrimaryScanner(value: ScannerPrimarySearchList) {
        if(this.checkAvaiabilityofComponent(value)) {



            this._selectedPrimaryScanner = value;
            this.canShowScannerSearchForm = true;
            this.showScanButton = true;

            if(this.selectedSavedScan != "") {
                this.canSelectedSavedScanUpdate = true;
            }

        } else {
            //  if(this.dataService.mo.modalService)
            // showScannerTrialReminderModal(this.modalService,this.mobileMode)
            // let modalService:NgbModal = new NgbModal()
            // this
            // if(modalService)
            // {
            //
            // }
            this.canShowScannerSearchForm = false;
            if(this.userId != 0) {
                this.globaGridMode.scannerReminderLauncher.next(true);
            }

        }
    }

    private _modalService?: NgbModal;
    public get modalService(): NgbModal | undefined {
        return this._modalService;
    }
    public set modalService(value: NgbModal | undefined) {
        this._modalService = value;
    }

    private _selectedPrimaryScanner_Narrow: ScannerPrimarySearchList = ScannerPrimarySearchList.SCANNER_WIZARD;
    public get selectedPrimaryScanner_Narrow(): ScannerPrimarySearchList {
        return this._selectedPrimaryScanner_Narrow;
    }
    public set selectedPrimaryScanner_Narrow(value: ScannerPrimarySearchList) {
        this._selectedPrimaryScanner_Narrow = value;
    }

    private _canShowSearchForm: boolean = false;
    public get canShowScannerSearchForm(): boolean {
        return true;
        return this._canShowSearchForm;
    }
    public set canShowScannerSearchForm(value: boolean) {
        this._canShowSearchForm = value;
    }

    private _showScanButton: boolean = false;
    public get showScanButton(): boolean {
        return true;
        return this._showScanButton;
    }
    public set showScanButton(value: boolean) {
        this._showScanButton = value;
    }


    private _scannerSearch_side: ScannerSide | string = "NO";
    public get scannerSearch_side(): ScannerSide | string {
        return this._scannerSearch_side;
    }
    public set scannerSearch_side(value: ScannerSide | string) {
        this._scannerSearch_side = value;
        if(this.selectedSavedScan != "") {
            this.canSelectedSavedScanUpdate = true;
        }
    }

    private _scannerSearch_Narrow_side: ScannerSide | string = "NO";
    public get scannerSearch_Narrow_side(): ScannerSide | string {
        if(!this.usePrimarySide) {
            return this._scannerSearch_Narrow_side;
        } else {
            return this.scannerSearch_side;
        }
    }
    public set scannerSearch_Narrow_side(value: ScannerSide | string) {
        this._scannerSearch_Narrow_side = value;
        if(this.selectedSavedScan != "") {
            this.canSelectedSavedScanUpdate = true;
        }
    }

    private _usePrimarySide: boolean = false;
    public get usePrimarySide(): boolean {
        return this._usePrimarySide;
    }
    public set usePrimarySide(value: boolean) {
        this._usePrimarySide = value;
    }

    private _scannerSearch_chartingstudy: ScannerChartingStudy | string = "";
    public get scannerSearch_chartingstudy(): ScannerChartingStudy | string {
        return this._scannerSearch_chartingstudy;
    }
    public set scannerSearch_chartingstudy(value: ScannerChartingStudy | string) {
        this._scannerSearch_chartingstudy = value;
        if(this.selectedSavedScan != "") {
            this.canSelectedSavedScanUpdate = true;
        }
    }

    private _scannerSearch_Narrow_chartingstudy: ScannerChartingStudy | string = "";
    public get scannerSearch_Narrow_chartingstudy(): ScannerChartingStudy | string {
        return this._scannerSearch_Narrow_chartingstudy;
    }
    public set scannerSearch_Narrow_chartingstudy(value: ScannerChartingStudy | string) {
        this._scannerSearch_Narrow_chartingstudy = value;
        if(this.selectedSavedScan != "") {
            this.canSelectedSavedScanUpdate = true;
        }
    }

    private _scannerSearch_market: quoteFilterTabsList = quoteFilterTabsList.FOREX;
    public get scannerSearch_market(): quoteFilterTabsList {
        return this._scannerSearch_market;
    }
    public set scannerSearch_market(value: quoteFilterTabsList) {
        this._scannerSearch_market = value;
        if(this.selectedSavedScan != "") {
            this.canSelectedSavedScanUpdate = true;
        }
    }

    public currentScanMarket: quoteFilterTabsList = quoteFilterTabsList.FOREX;

    private _scannerSearch_period: HistoryItemPeriod | string = "NO";
    public get scannerSearch_period(): HistoryItemPeriod | string {
        return this._scannerSearch_period;
    }
    public set scannerSearch_period(value: HistoryItemPeriod | string) {

        console.log("PERIODS_SET")
        console.log(value);

        this._scannerSearch_period = this.getCorrectPeriod(<HistoryItemPeriod> value);



        if(this.selectedSavedScan != "") {
            this.canSelectedSavedScanUpdate = true;
        }
    }


    public getCorrectPeriod(value: HistoryItemPeriod) {

        let tempPeriods = historyPeriods().filter(l => {
            return l.id == value
        })

        if(this.currentProvider== Providers.GAIN)
        {
            if(this.localProviderPeriods.length > 0) {
                tempPeriods = this.localProviderPeriods;
            }

            let period = this.localProviderPeriods.find(v=>{
                return v.id == value;
            })

            if(period!==undefined)
            {
                 return value;
            }
            else
            {
                return this.localProviderPeriods[0].id;
            }
           
        }


        if(tempPeriods[0] == undefined) {
            return value;
        }

        let temp = this.periodsList.filter(v => {
            return v.id == value || (v.id != value && v.Order >= tempPeriods[0].Order)
        })

        

        return temp && temp.length>0?temp[0].id:-1;
    }


    private _currentScannerIndicator: any;
    public get currentScannerIndicator(): any {
        return this._currentScannerIndicator;
    }
    public set currentScannerIndicator(value: any) {
        this._currentScannerIndicator = value;
    }


    private _scannerSearch_Narrow_period: HistoryItemPeriod | string = "NO";
    public get scannerSearch_Narrow_period(): HistoryItemPeriod | string {
        return this._scannerSearch_Narrow_period;
    }
    public set scannerSearch_Narrow_period(value: HistoryItemPeriod | string) {

        console.log("PERIODS_NARROW_SET")
        console.log(this.currentProvider);

        this._scannerSearch_Narrow_period = this.getCorrectPeriod(<HistoryItemPeriod> value);;
        if(this.selectedSavedScan != "") {
            this.canSelectedSavedScanUpdate = true;
        }
    }

    private _scannerCurrentRule: any;
    public get scannerCurrentRule(): any {
        return this._scannerCurrentRule;
    }
    public set scannerCurrentRule(value: any) {
        this._scannerCurrentRule = value;
        if(this.selectedSavedScan != "") {
            this.canSelectedSavedScanUpdate = true;
        }
    }

    private _scannerCurrentRule_Narrow: any;
    public get scannerCurrentRule_Narrow(): any {
        return this._scannerCurrentRule_Narrow;
    }
    public set scannerCurrentRule_Narrow(value: any) {
        console.log("SCvalue");
        console.log(value)
        this._scannerCurrentRule_Narrow = value;
        if(this.selectedSavedScan != "") {
            this.canSelectedSavedScanUpdate = true;
        }
    }

    private _currentCountToScan: number = 0;
    public get currentCountToScan(): number {
        return this._currentCountToScan;
    }
    public set currentCountToScan(value: number) {
        this._currentCountToScan = value;
    }

    private _narrowScanComponent: ScannerPrimarySearchList | undefined = ScannerPrimarySearchList.SCANNER_NA;
    public get narrowScanComponent(): ScannerPrimarySearchList | undefined {
        return this._narrowScanComponent || ScannerPrimarySearchList.SCANNER_NA;
    }
    public set narrowScanComponent(value: ScannerPrimarySearchList | undefined) {
        this._narrowScanComponent = value || ScannerPrimarySearchList.SCANNER_NA;
        if(this.selectedSavedScan != "") {
            this.canSelectedSavedScanUpdate = true;
        }
    }



    private _scannedCount: number = 0;
    public get scannedCount(): number {
        return this._scannedCount;
    }
    public set scannedCount(value: number) {
        this._scannedCount = value;

        if(this.scannedCount == this.currentCountToScan) {
            this.scannedCount = 0;

            callNextAsync(this.globaGridMode.scanFinished, value);
        }
    }

    private _hardFinish: boolean = false;
    public get hardFinish(): boolean {
        return this._hardFinish;
    }
    public set hardFinish(value: boolean) {
        this._hardFinish = value;
    }


    public scanStartTime: number = 0;
    private _scanFinished: boolean = false;
    public get scanFinished(): boolean {
        return this._scanFinished;
    }
    public set scanFinished(value: boolean) {
        if(value == false) {
            //  this.showBackToResults = value;
        }

        this._scanFinished = value;
        if(value == true) {
            this.lastScanPrimaryType = this.selectedPrimaryScanner;

            if(this.processNarrowScan) {
                this.narrowscanFinished = true;
            }

            //   this.processNarrowScan = false;
        }
    }

    private _processNarrowScan: boolean = false;
    public get processNarrowScan(): boolean {
        return this._processNarrowScan;
    }
    public set processNarrowScan(value: boolean) {
        this._processNarrowScan = value;
    }

    private _narrowscanFinished: boolean = false;
    public get narrowscanFinished(): boolean {
        return this._narrowscanFinished;
    }
    public set narrowscanFinished(value: boolean) {
        this._narrowscanFinished = value;
    }

    private _scanresultsView?: ChartDisplayMode;
    public get scanresultsView(): ChartDisplayMode | undefined {
        return this._scanresultsView;
    }
    public set scanresultsView(value: ChartDisplayMode | undefined) {
        this._scanresultsView = value;
    }

    private _showBackToResults: boolean = false;
    public get showBackToResults(): boolean {
        if(this.scanresultsView != this.chartDisplayMode || this.showScannerPage || this.showLandingPage) {
            return false;
        }

        return this._showBackToResults;
    }
    public set showBackToResults(value: boolean) {

        if(this._showBackToResults == true && value == false) {
            // this.activeTab
            callNextAsync(this.quoteTabsActiveModeService.subscriber, this._activeTab);
            this.emitBasketChange(this.activeBasket);
            this.activeTab = this._activeTab
                ;

            this.removeScnannerIndicators();
            this._showBackToResults = value;
            //  this.currentScannerIndicator = null;
        }

        this._showBackToResults = value;
    }


    public removeScnannerIndicators() {
        if(this.charts["ach1"].instance != undefined && this.currentScannerIndicator != undefined && this.currentScannerIndicator.length > 0) {

            //   let l = this.currentScannerIndicator[0].length;
            let plotNum = this.currentScannerIndicator[1];
            //  if(this.currentScannerIndicator[0].length>1)
            //     {


            if(this.currentScannerIndicator[3] == "bb") {
                this.charts["ach1"].instance.chart.plot(this.currentScannerIndicator[1]).removeSeriesAt(this.currentScannerIndicator[2].upperSeries().getIndex())
                this.charts["ach1"].instance.chart.plot(this.currentScannerIndicator[1]).removeSeriesAt(this.currentScannerIndicator[2].lowerSeries().getIndex())
                this.charts["ach1"].instance.chart.plot(this.currentScannerIndicator[1]).removeSeriesAt(this.currentScannerIndicator[2].middleSeries().getIndex())
                this.charts["ach1"].instance.chart.plot(this.currentScannerIndicator[1]).removeSeriesAt(this.currentScannerIndicator[2].rangeSeries().getIndex())

            }

            if(this.currentScannerIndicator[3] == "macd") {
                this.charts["ach1"].instance.chart.plot(this.currentScannerIndicator[1]).removeSeriesAt(this.currentScannerIndicator[2].macdSeries().getIndex())
                this.charts["ach1"].instance.chart.plot(this.currentScannerIndicator[1]).removeSeriesAt(this.currentScannerIndicator[2].signalSeries().getIndex())
                this.charts["ach1"].instance.chart.plot(this.currentScannerIndicator[1]).removeSeriesAt(this.currentScannerIndicator[2].histogramSeries().getIndex())


            }

            if(this.currentScannerIndicator[3] == "ema") {
                this.charts["ach1"].instance.chart.plot(this.currentScannerIndicator[1]).removeSeriesAt(this.currentScannerIndicator[2].getIndex())
            }

            if(this.currentScannerIndicator[3] == "rsi") {
                this.charts["ach1"].instance.chart.plot(this.currentScannerIndicator[1]).removeSeriesAt(this.currentScannerIndicator[2].getIndex())
            }

            if(this.charts["ach1"].instance != undefined) {
                (<any> this.currentScannerIndicator[2]).dispose();;

                if(plotNum == 2) {
                    let seriesNum = this.charts["ach1"].instance.chart.plot(this.currentScannerIndicator[1]).getSeriesCount();
                    if(seriesNum == 0) {
                        (<any> this.charts["ach1"].instance.chart.plot(this.currentScannerIndicator[1])).dispose();
                    }
                }
            } this.currentScannerIndicator = [];

            // }
            // else
            // {


            //      this.charts[ "ach1" ].instance.chart.plot(this.currentScannerIndicator[1]).removeSeriesAt( this.currentScannerIndicator[0]);
            //     (<any>this.currentScannerIndicator[2]).dispose();

            //      if(plotNum==2)
            //      {
            //        let seriesNum =  this.charts[ "ach1" ].instance.chart.plot(this.currentScannerIndicator[1]).getSeriesCount();
            //         if(seriesNum==0)
            //         {
            //             (<any>this.charts[ "ach1" ].instance.chart.plot(this.currentScannerIndicator[1])).dispose();
            //         }
            //      }


            //  //  (<any>this.currentScannerIndicator[2]) = null;
            // }


        }
    }
    private _lastScanPrimaryType: ScannerPrimarySearchList = ScannerPrimarySearchList.SCANNER_WIZARD;
    public get lastScanPrimaryType(): ScannerPrimarySearchList {
        return this._lastScanPrimaryType;
    }
    public set lastScanPrimaryType(value: ScannerPrimarySearchList) {
        this._lastScanPrimaryType = value;
    }

    private _showScanResults: boolean = false;
    public get showScanResults(): boolean {
        return this._showScanResults;
    }
    public set showScanResults(value: boolean) {
        this._showScanResults = value;
    }

    private _scanResultList: any[] = [];
    public get scanResultList(): any[] {
        return this._scanResultList;
    }
    public set scanResultList(value: any[]) {
        this._scanResultList = value;
    }

    private _scanResultListNarrow: any[] = [];
    public get scanResultListNarrow(): any[] {
        return this._scanResultListNarrow;
    }
    public set scanResultListNarrow(value: any[]) {
        this._scanResultListNarrow = value;
    }

    private _scanInProgress: boolean = false;
    public get scanInProgress(): boolean {
        return this._scanInProgress;
    }
    public set scanInProgress(value: boolean) {
        this._scanInProgress = value;
    }

    private _allowScanProcessNarrow: boolean = false;
    public get allowScanProcessNarrow(): boolean {
        return this._allowScanProcessNarrow;
    }
    public set allowScanProcessNarrow(value: boolean) {
        this._allowScanProcessNarrow = value;
    }

    private _allowScanProcess: boolean = true;
    public get allowScanProcess(): boolean {
        return this._allowScanProcess;
    }
    public set allowScanProcess(value: boolean) {
        this._allowScanProcess = value;
    }

    private _noResults: boolean = true;
    public get noResults(): boolean {
        return this._noResults;
    }
    public set noResults(value: boolean) {
        this._noResults = value;
    }


    public savedScans: ISavedScan = {item: "", wizard: [], charting: [], entrysignals: [], tiWizard: []};
    public savedScansOnePool: ISavedScansOnePool[] = [];
    private _selectedSavedScan: string = "";
    public get selectedSavedScan(): string {
        return this._selectedSavedScan;
    }
    public set selectedSavedScan(value: string) {
        this._selectedSavedScan = value;
    }

    public scanHistory: ScanHistory[] = [];



    private _canSelectedSavedScanUpdate: boolean = false;
    public get canSelectedSavedScanUpdate(): boolean {
        return this._canSelectedSavedScanUpdate;
    }
    public set canSelectedSavedScanUpdate(value: boolean) {
        this._canSelectedSavedScanUpdate = value;
    }

    addSavedScan() {
        this.setHasChanges(false, () => {
            this.setChangedProperty("savedScans", true);
            this.setChangedProperty("savedScansOnePool", true);
            this.save();
        });
    }

    private _initLoadScan: any = null;
    public get initLoadScan(): any {
        return this._initLoadScan;
    }
    public set initLoadScan(value: any) {
        this._initLoadScan = value;
    }

    /**END SCANNER */

    private _funnelLoginWindow = false;
    public get funnelLoginWindow() {
        return this._funnelLoginWindow;
    }
    public set funnelLoginWindow(value) {
        this._funnelLoginWindow = value;
    }

    private _activeFirstLogin: boolean = false;
    public get activeFirstLogin(): boolean {
        return this._activeFirstLogin;
    }
    public set activeFirstLogin(value: boolean) {
        this._activeFirstLogin = value;
    }

    private _currentProvider: Providers = Providers.DEMO;
    public get currentProvider(): Providers {
        return this._currentProvider;
    }

    public set currentProvider(value: Providers) {

        this._currentProvider = value;
        this.periodsList = this.updatePeriodList();
    }

    private _periodsList: {
        id: number;
        label: string;
        css: string;
        Order: number;
        Standard?: boolean;
        Oanda?: boolean;
    }[] = this.updatePeriodList();

    public get periodsList(): {
        id: number;
        label: string;
        css: string;
        Order: number;
        Standard?: boolean;
        Oanda?: boolean;
    }[] {
        return this._periodsList;
    }

    public set periodsList(
        value: {
            id: number;
            label: string;
            css: string;
            Order: number;
            Standard?: boolean;
            Oanda?: boolean;
        }[]
    ) {
        this._periodsList = value;
    }

    public localProviderPeriods: any[] = [];
    public updatePeriodList(): {
        id: number;
        label: string;
        css: string;
        Order: number;
        Standard?: boolean;
        Oanda?: boolean;
    }[] {

        let periods = this.dataService.getProviderPeriods();
        if(periods.length > 0) {
            let selectedPeriods = historyPeriods().filter(x => {
                return periods.indexOf(x.id) > -1
            });
            this.localProviderPeriods = selectedPeriods;
            return selectedPeriods;
        }

        this.localProviderPeriods = [];

        return historyPeriods().filter(x => {
            if(this.currentProvider == Providers.OANDA) {
                return x.Oanda == true;
            } else {
                return x.Standard == true;
            }
        });


    }

    public allowFunnelAction: boolean = false;
    public funnelTagId: number = 2144;

    public loginError: boolean = false;
    public LoginModalCreated: boolean = false;

    private _providerInstruments: {
        Symbol: string;
        MarginPercentage: number;
    }[] = [];
    public get providerInstruments(): {
        Symbol: string;
        MarginPercentage: number;
    }[] {
        return this._providerInstruments;
    }
    public set providerInstruments(value: {
        Symbol: string;
        MarginPercentage: number;
    }[]) {
        this._providerInstruments = value;
    }

    private setUserDataToSession(loginRs: LoginRs, userName: string, password: string, rememberme: boolean) {
        // needed for relogin after wakeup
        window.sessionStorage.setItem("userName", userName);
        window.sessionStorage.setItem("userPassword", password);
        if(this.specialToken && this.specialToken != '') {
            rememberme = true;
            password = loginRs.Password;
        }
        if(rememberme) {
            this.cookieService.setCookie("_r", "1", 100, "/");
            this.cookieService.setCookie("_xu", btoa(userName), 100, "/");
            this.cookieService.setCookie("_zp", btoa(password), 100, "/");
            if(loginRs.Provider)
                this.cookieService.setCookie("_provider", loginRs.Provider, 100, "/");
        } else {
            this.cookieService.deleteCookie("_r");
            this.cookieService.deleteCookie("_xu");
            this.cookieService.deleteCookie("_zp");
            this.cookieService.deleteCookie("_provider");
        }
        this.cookieService.setCookie("orderLoginAction", "true", 1, "/");
        this.cookieService.setCookie("IsLoggedIn", "true", 1, "/");
    }

    public providerModalHome?: HomeComponent;
    public gainLoginResponse?: LogOnInternalRs;
    public scannerPopupShowedBySession: boolean = false;
    public ProcessLoginResponse(
        loginRs: LoginRs,
        userName: string,
        password: string,
        rememberme: boolean
    ): Promise<any> {
        return new Promise<any>((rs, rj) => {
            if(loginRs.OK == true) {
                this.loginError = false;
                this.userName = userName;
                this.userPassword = password;
                this.userId = loginRs.UserId;
                this.userType = loginRs.UserType == "Regular" ? UserType.Regular : UserType.Tournament;
                this.activeAccountId = loginRs.ActiveAccountId;
                this.mainAccountId = loginRs.ActiveAccountId;

                if(this.challangeToken == "2") {
                    loginRs.FirstLogin = true;
                }

                if(loginRs.Provider == "OANDA" && loginRs.IsProviderBound == false) {
                    //  alert("NO BOUNDS")
                }
                else {
                    this.setUserDataToSession(loginRs, userName, password, rememberme);
                    this.appStoreData();
                    if(loginRs.FirstLogin) {
                        let funnelUser = false;

                        if(this.userTagList != undefined) {
                            if(this.userTagList.indexOf(this.funnelTagId) > -1) {
                                funnelUser = true;
                            }
                            this.funnelLoginWindow = funnelUser;
                        }

                        if(funnelUser) {
                            this.processFunnelLogin();
                            this.isFirstLogin = true;
                            this.showLandingPage = true;
                        } else {

                            if(this.challangeToken == "2") {
                                this.autoTrialRegistration();
                            }
                            else {
                                this.onFirstLogin();
                                this.isFirstLogin = true;
                                this.showLandingPage = true;
                            }

                        }
                    }




                    this.alertsAccess = loginRs.HasAlertsAccess;
                    this.alerts = (loginRs.Alerts || [])
                        .sort((a, b) => (new Date(b.Date) as any) - (new Date(a.Date) as any))
                        .slice(0, 10);
                    this.alertStateEntries = loginRs.AlertStateEntries;
                    this.SymbolInfoes = loginRs.SymbolInfoes;
                    var boxesToMerge: BoxQuotaData[] = [];
                  
                    loginRs.SymbolInfoes.filter(x => x.Symbol != "EOSUSD" && x.Symbol != "PNCUSD").forEach(v => {
                        if((initRequest.initOrder || []).indexOf(v.Symbol) == -1) {
                            var bd: BoxQuotaData = new BoxQuotaData(this);
                            bd.Symbol = v.Symbol;
                       //     bd.Pip = getPipBySymbol(v.Symbol);
                            bd.Bid = -1;
                            bd.Ask = -1;
                            bd.Type = v.Type;
                            bd.Decimal = v.Decimals;
                            bd.MarginPerc = v.MarginPerc;
                            boxesToMerge.push(bd);
                        } else {
                            this.boxes[this.boxes.findIndex(b => b.Symbol == v.Symbol)].Decimal = v.Decimals;
                            // this.boxes[(initRequest.initOrder || []).indexOf(v.Symbol)].Decimal = v.Decimals;
                        }
                    });
                    boxesToMerge.sort((a, b) => (a.Symbol < b.Symbol ? -1 : a.Symbol > b.Symbol ? 1 : 0));

                    /**Firefox FIX */
                    boxesToMerge.forEach(v => {
                        this.initOrderSymbol.push(v.Symbol);
                    });

                    this.boxes = this.boxes.concat(boxesToMerge);
               
                    // debugger;
                    this.boxes.forEach(v=>{
                        v.Spread == (v.Ask-v.Bid)/v.Pip;
                    })
                  
                    this.app.tick()
                   

                    /**Firefox FIX */
                    let sortOrder = this.initOrderSymbol;
                    this.boxes.sort(function(a: any, b: any) {
                        var A = a,
                            B = b;

                        if(sortOrder.indexOf(A.Symbol) > sortOrder.indexOf(B.Symbol)) {
                            return 1;
                        } else {
                            return -1;
                        }
                    });

                    this.boxes.map(item => {
                        item.initialSortOrder = this.initOrderSymbol.indexOf(item.Symbol);
                    });

                    this.loadedSymbolsTypeSplit.forex = this.boxes
                        .filter(x => x.Type == SymbolTypeEnum.Forex)
                        .map(x => x.Symbol);
                    this.loadedSymbolsTypeSplit.crypto = this.boxes
                        .filter(x => x.Type == SymbolTypeEnum.Crypto)
                        .map(x => x.Symbol);
                    this.loadedSymbolsTypeSplit.equity = this.boxes
                        .filter(x => x.Type == SymbolTypeEnum.Equity)
                        .map(x => x.Symbol);
                    this.loadedSymbolsTypeSplit.commodity = this.boxes
                        .filter(x => x.Type == SymbolTypeEnum.Commodity)
                        .map(x => x.Symbol);
                    this.loadedSymbolsTypeSplit.bonds = this.boxes
                        .filter(x => x.Type == SymbolTypeEnum.Bonds)
                        .map(x => x.Symbol);
                    this.loadedSymbolsTypeSplit.index = this.boxes
                        .filter(x => x.Type == SymbolTypeEnum.Index)
                        .map(x => x.Symbol);

                    this.demoUserList = this.getDemoUsers();

                    this.updateUserList().then(() => {
                        this.getAllAccountsForUserById(this.userId).then(() => {
                            //loginRs.Settings.forEach(us => this.setToUserStore(us.Key, us.Setting));
                            /**TODO _ CHANGE When server start with  
                            *  case "SettingsRs":
                                this.settingsRsResponse(<any>response)
                                break;
                            * 
                                DO not remove until settings will works
                            */
                            this.loadUserSets()
                                .then(r => {
                                    if(this.userSets && Object.keys(this.userSets).length > 0) {
                                        this._selectedSet = Object.keys(this.userSets)[0];
                                    }



                                    if(this.providerModalHome)
                                        this.providerModalHome.showProviderModal(loginRs.Provider).then(v => {
                                            // alert("ISGAINACTION");
                                            console.log("this.gainLoginResponse");
                                            console.log(this.gainLoginResponse);

                                            this.load()
                                                .then(() => {


                                                    if(loginRs.Provider == Providers.OANDA && loginRs.IsProviderBound == true) {
                                                        console.log("LOGIN LIVE ACTION");
                                                        let accounts: AccountProvider[] = [];
                                                        (loginRs.ProviderAccounts as any[]).forEach((item, index) => {
                                                            accounts.push(new AccountProvider({id: index, accountName: item.AccountName, balance: item.Balance, pnL: item.PnL, accountProviderId: item.AccountID, userId: loginRs.UserId, Currency: item.Currency}));
                                                        });
                                                        this.accounts = accounts;
                                                        let active = this.accounts[0];//.find(v=>v.accountName=="Primary");

                                                        if(loginRs.ProviderInstruments) {
                                                            this.providerInstruments = loginRs.ProviderInstruments;
                                                        }

                                                        if(accounts.length > 0) {
                                                            if(active) {
                                                                this.activeAccountId = active.id;
                                                          //      this.activeAccountIdBySet = active.id;
                                                            }
                                                            else {
                                                                this.activeAccountId = 0;
                                                          //      this.activeAccountIdBySet = 0;
                                                            }
                                                        }
                                                        
                                                        // let selected = <AccountProvider> this.accounts.find(v => v.id == this.activeAccountId);
                                                        //   AccountName: "ISTLAV10-1", AccountID:
                                                        this.currentProvider = Providers.OANDA;
                                                        this.activeSymbolType = SymbolTypeEnum.Forex;
                                                        this.globaGridMode.liveLoginAction.next(this.currentProvider);
                                                        // this.dataService.sendRequest( {
                                                        //     Cmd: DataService.TYPE_SWITCHACCOUNT,
                                                        //     Data: { 
                                                        //         AccountId: selected.accountProviderId ,
                                                        //         Provider: this.currentProvider,
                                                        //         AccountID: selected.accountProviderId
                                                        //        }
                                                        //   } );
                                                        this.bounded = true;
                                                    }
                                                    if(loginRs.Provider == Providers.GAIN) {

                                                        ///TO DO MOVE TO FUNXTION
                                                        if(this.gainLoginResponse) {
                                                            this.afterGainLogin(loginRs.UserId);
                                                            // this.globaGridMode.liveLoginAction.next(this.currentProvider);
                                                        }
                                                    }

                                                    this.loggedIn = true;


                                                    rs();
                                                })
                                                .catch(e => {
                                                    console.log(e);
                                                });

                                        }).catch(e => {
                                            console.log(e);
                                        });
                                })
                                .catch(e => {
                                    console.log(e);
                                });
                        });
                    });
                }
            } else {
                this.loginError = true;
                this.cookieService.deleteCookie("_r");
                this.cookieService.deleteCookie("_xu");
                this.cookieService.deleteCookie("_zp");
            }
        });
    }


    public clearProviderData(){
        this.accounts=[];
        this.dataService.periodCache={};
        this.dataService.lastQuotes={};
        this.dataService.historyRequests={};
        this.periodsList=[];
        this.currentAccountMoneyLine={
            Balance: 0,
            MarginInUse: 0,
            SumOfPips: 0,
            SumOfUPLUSD: 0,
            SumOfPipsHistory: 0,
            SumOfPLUSDHistory: 0,
            PnL: 0,
            AccountValue: 0
        };

        this.currentAccountInformation=undefined;
        this.selectedChallengeHistoryAccInfo=undefined;

        this.historyChallengeAccountMoneyLine = {
            Balance: 0,
            MarginInUse: 0,
            SumOfPips: 0,
            SumOfUPLUSD: 0,
            SumOfPipsHistory: 0,
            SumOfPLUSDHistory: 0,
            PnL: 0,
            AccountValue: 0
        };
    
        this.visibleHistoryData= [];
        this.visibleHistoryChallengeData= [];

        if(this.charts["ach1"].instance){
            this.charts["ach1"].instance.resetAllDataTables();
        //    this.charts["ach1"].instance.resetAllChartElements()
        }

        if(this.charts["ach2"].instance){
            this.charts["ach2"].instance.resetAllDataTables();
          //  this.charts["ach2"].instance.resetAllChartElements()
        }

        if(this.charts["ach3"].instance){
            this.charts["ach3"].instance.resetAllDataTables();
        //    this.charts["ach3"].instance.resetAllChartElements()
        }

        if(this.charts["ach4"].instance){
            this.charts["ach4"].instance.resetAllDataTables();
         //   this.charts["ach4"].instance.resetAllChartElements()
        }
    }

    public afterGainLogin(userIdN: number) {
        if(this.gainLoginResponse) {
           
            
            let accounts: AccountProvider[] = [];
            (this.gainLoginResponse.ProviderAccounts as any[]).forEach((item, index) => {
                accounts.push(new AccountProvider({id: index, accountName: item.AccountName, balance: item.Balance, pnL: item.PnL, accountProviderId: item.AccountID, userId: userIdN, Currency: item.Currency}));
            });
            this.accounts = accounts;
            let active = this.accounts[0];
            this.dataService.switchProvider(Providers.GAIN);
            this.currentProvider = Providers.GAIN;
            this.activeSymbolType = SymbolTypeEnum.Forex;
            

            if(this.gainLoginResponse.ProviderInstruments) {
                //  this.providerInstruments = this.gainLoginResponse.ProviderInstruments.slice(0,5);
                console.log(this.gainLoginResponse.ProviderInstruments);
                this.runSymbolFilter(this.gainLoginResponse.ProviderInstruments)
            }
            if(accounts.length > 0) {
                if(active) {
                    this.activeAccountId = active.id;
                    this.activeAccountIdBySet = active.id;
                }
                else {
                    this.activeAccountId = 0;
                    this.activeAccountIdBySet = 0;
                }
            }
            this.globaGridMode.liveLoginAction.next(this.currentProvider);
        }
    }


    public runSymbolFilter(instruments: any[]) {
        if(instruments && instruments.length > 0) {
            this.providerInstruments = instruments;

            this.switchProviderUnkwonSymbol();

            if(this.providerInstruments.length > 0) {
                let symbols = this.providerInstruments.map(v => {
                    return v.Symbol
                });

                this.allowedForexSymbols = symbols;

                if(this.mobileMode != "desktop") {
                    this.globaGridMode.changeActiveBasket.next(this.activeBasket)
                }

            }

        }
    }










    public get currentAccountCurrencyCode() {
        let findAccount = <AccountProvider> this.accounts.find(a => a.id == this.activeAccountId);

        if(findAccount) {
            if(this.currentProvider == "OANDA") {
                return (findAccount.Currency == "USD" || findAccount.Currency == "CAD") ? findAccount.Currency : "USD";
            }
        }
        return "USD";
    }

    public getCurrencyInformation(currencyCode: string) {

        switch(currencyCode) {
            case "USD":
                return {symbol: "$", position: "before"};

            case "CAD":
                return {symbol: "CA$", position: "before"};

        }

        return {symbol: "", position: "before"};;
    }

    public switchProviderUnkwonSymbol() {
        Object.keys(this.charts).forEach(k => {
            var cfg = this.charts[k];
            var chart = <AChartComponent> cfg.instance;
            if(chart) {
                let findSymbol = this.providerInstruments.find(v => v.Symbol == chart.symbol);

                if(findSymbol == undefined) {
                    let mapInit = this.boxes.map(v => {
                        return v.Symbol
                    });
                    let mapProvider = this.providerInstruments.map(v => {return v.Symbol});

                    let intersction = mapInit.filter(l => -1 !== mapProvider.indexOf(l))
                    //              console.log(intersction);
                    chart.symbol = intersction[0];
                }


                //console.log([chart.symbol,findSymbol,this.workspace.currentProvider,(response as SwitchProviderRs).]);
            }
        })
    }










    private _bounded: boolean = false;
    public get bounded(): boolean {
        return this._bounded;
    }
    public set bounded(value: boolean) {
        this._bounded = value;
    }

    public onFirstLogin() {
        Utils.waitFor(
            () => this.loggedIn,
            () => {
                if(this.challangeToken != "1") {
                    this.tutorialPanelShown = true;
                    this.activeTutorialVideo = "wa3aqbaede";
                    if(this.tutorialVideoWindow) this.tutorialVideoWindow.bigWindow = true;
                }
                else {
                    callNextAsync(this.globaGridMode.funnelUserActive, true);
                }

            }
        );
    }

    public processFunnelLogin() {
        Utils.waitFor(
            () => this.loggedIn,
            () => {
                //   this.tutorialPanelShown = true;
                //    this.activeTutorialVideo = 'wa3aqbaede';
                //    if(this.tutorialVideoWindow) this.tutorialVideoWindow.bigWindow = true;
                //alert("FUCKTHEPOLICE MAN");

                callNextAsync(this.globaGridMode.funnelUserActive, true);
            }
        );
    }

    public userTagList?: number[];

    public updateUserList(): Promise<any> {
        return new Promise<any>((rs, rj) => {
            this.loadAccounts(this.userName)
                .then(response => {
                    if(response !== null) {
                        this.accounts = response;
                        this.allAccount = response;
                    }
                    rs();
                })
                .catch(error => {
                    rj(error);
                });
        });
    }

    private showPreloader(achart: AChartComponent): Promise<void>{
        return new Promise<void>((rs,rj)=>{
            if(achart){
                achart.showPreloader().then(()=>rs()).catch(e=>rj(e));
            } else rs();
        });
    }
    private hidePreloader(achart: AChartComponent): Promise<void>{
        return new Promise<void>((rs,rj)=>{
            if(achart){
                achart.hidePreloader().then(()=>rs()).catch(e=>rj(e));
            } else rs();
        });
    }

    private updateChartDisplay(achart: AChartComponent,cd:ChartDisplayMode): Promise<void>{
        return new Promise<void>((rs,rj)=>{
            if(achart){
                achart.updateChartDisplay(cd).then(()=>rs()).catch(e=>rj(e));
            } else rs();
        });
    }

    public mainAccountId: number = 0;
    public changeSelectedSet(value: string): Promise<void> {
        // debugger;
        return new Promise<void>((rs, rj) => {
            if(this.selectedSet != value) {
                this._inTick++;
                this.selectedSet = value;
                var ach1 = this.charts["ach1"].instance!;
                var ach2 = this.charts["ach2"].instance!;
                var ach3 = this.charts["ach3"].instance!;
                var ach4 = this.charts["ach4"].instance!;
                
                Promise.all([this.showPreloader(ach1), this.showPreloader(ach2), this.showPreloader(ach3), this.showPreloader(ach4)])
                    .then(() => {
                        //   Promise.all([                            
                        ach1.hideIndicators(ach1.Config.wizardIndicatorInstances);
                        if(ach2){
                            ach2.hideIndicators(ach2.Config.wizardIndicatorInstances);
                            ach2.hideIndicators(ach2.Config.chartIndicatorInstances);
                        }
                        if(ach3){
                            ach3.hideIndicators(ach2.Config.wizardIndicatorInstances);
                            ach3.hideIndicators(ach2.Config.chartIndicatorInstances);
                        }
                        if(ach4){
                            ach4.hideIndicators(ach2.Config.wizardIndicatorInstances);
                            ach4.hideIndicators(ach2.Config.chartIndicatorInstances);
                        }

                            // ach2.hideIndicators(ach2.Config.wizardIndicatorInstances);
                            // ach3.hideIndicators(ach3.Config.wizardIndicatorInstances);
                            // ach4.hideIndicators(ach4.Config.wizardIndicatorInstances);
                            // ach1.hideIndicators(ach1.Config.chartIndicatorInstances);
                            // ach2.hideIndicators(ach2.Config.chartIndicatorInstances);
                            // ach3.hideIndicators(ach3.Config.chartIndicatorInstances);
                            // ach4.hideIndicators(ach4.Config.chartIndicatorInstances);
                        //   ])
                        //     .then(() => {
                        this.userSetload(value)
                            .then(() => {
                                Promise.all([
                                    this.updateChartDisplay(ach1,this.chartDisplayMode),
                                    this.updateChartDisplay(ach2,this.chartDisplayMode),
                                    this.updateChartDisplay(ach3,this.chartDisplayMode),
                                    this.updateChartDisplay(ach4,this.chartDisplayMode)
                                ])
                                    .then(() => {
                                        this._inTick--;
                                        this.AppTick()
                                            .then(() => {
                                                Promise.all([
                                                    this.hidePreloader(ach1),
                                                    this.hidePreloader(ach2),
                                                    this.hidePreloader(ach3),
                                                    this.hidePreloader(ach4),
                                                ])
                                                    .then(() => {
                                                        rs();
                                                    })
                                                    .catch(e => {
                                                        console.error(e);
                                                    });
                                            })
                                            .catch(e => {
                                                console.error(e);
                                            });
                                    })
                                    .catch(e => {
                                        console.error(e);
                                    });
                            })
                            .catch(e => {
                                console.error(e);
                            });
                    })
                    .catch(e => {
                        console.error(e);
                    });
                // })
                // .catch(e => {
                //     console.error(e);
                // });
            } else {
                rs();
            }
        });
    }

    private getDemoUsers() {
        let list: IDemoUser[] = [
            {Id: 12345, Name: "Demo user 1", EquityValue: 10000},
            {Id: 12346, Name: "Demo user 2", EquityValue: 10000}
        ];
        return list;
    }

    private async updateSymbolTicks(response: IServiceResponse) {
        if(response && response.T) {
            var T = response.T;
            T.forEach((value, i, a) => {
                var i = this.boxes.length;
                while(i) {
                    let x = this.boxes[i - 1];
                    if(x.Symbol == value.S) {
                        if(x.Bid !== value.B || x.Ask !== value.A) {
                            x.Bid = value.B;
                            x.Ask = value.A;
                            Object.keys(this.charts).forEach(k => {
                                var chartComponent = this.charts[k].instance;
                                if(!this.appSettings.PriceIndicatorFromPeriod){
                                    if(this.charts[k].Symbol == value.S && chartComponent) {
                                        chartComponent.updateAskIndicator(x.Ask, x.askUp);
                                    }
                                }
                            });
                        }
                        break;
                    }
                    i--;
                }
            });

        }
    }

    public getSymbolsTypeSlit(type: SymbolTypeEnum): string[] {
        switch(type) {
            case SymbolTypeEnum.Forex:
                return this.loadedSymbolsTypeSplit.forex;
                break;
            case SymbolTypeEnum.Crypto:
                return this.loadedSymbolsTypeSplit.crypto;
                break;
            case SymbolTypeEnum.Index:
                return this.loadedSymbolsTypeSplit.index;
                break;
            case SymbolTypeEnum.Equity:
                return this.loadedSymbolsTypeSplit.equity;
                break;
            case SymbolTypeEnum.Commodity:
                return this.loadedSymbolsTypeSplit.commodity;
                break;
            case SymbolTypeEnum.Bonds:
                return this.loadedSymbolsTypeSplit.bonds;
                break;
        }
        return [];
    }

    public getSymbolInfoByName(s: string): ISymbolInfo {
        let data = this.SymbolInfoes.filter(x => x.Symbol === s)[0];
        return data;
    }

    getCurrentUserName() {
        //var userName = sessionStorage.getItem("userName");
        return this._IsLoged ? this.userName : "";
    }
    private _IsLoged: boolean = false;
    IsLoged(): boolean {
        return this._IsLoged;
        // var userName = sessionStorage.getItem("userName");
        // return userName != undefined && userName != "";
    }

    private _canSave: boolean = true;
    public HasChanges(): boolean {
        var res = false;
        Object.keys(this._changedProperties)
            .filter(k => this.serverSettingsKeys.indexOf(k) >= 0)
            .forEach(k => {
                if(this._changedProperties[k]) {
                    res = res == true || this._changedProperties[k] == true;
                }
            });

        for(var c in this.charts) {
            res = res || this.charts[c].getHasChanges();
        }

        return res;
    }

    private _saveRequestCount: number = 0;
    private _loadRequestCount: number = 0;

    setHasChanges(v: boolean, action: () => void) {
        //if (!v) this.HasChanges = true;

        if(!v) {
            if(action) {
                action();
            }
            setTimeout(() => {
                this.save();
            }, 50);
        }
        var inRunOutsideAngular = (window as any)._runOutsideAngular === true;

        if(!inRunOutsideAngular && this.app) {
            this.AppTick();
        }
    }

    public _inTick: number = 0;

    public async AppTick() {
        if(!this._inTick) {
            if(this._inTick <= 0) {
                this._inTick++;
                this.app.tick();
                this._inTick = 0;
            }
        }
    }
public canSave:boolean = false;
    private _savePromise?: Promise<any>;
    save(force: boolean = false): Promise<any> {
        this._savePromise =
            this._savePromise ||
            new Promise<any>((rs, rj) => {
                if(!force) {
                    if(!this._canSave || this.HasChanges() != true) {
                        rs();
                        return;
                    }
                } else {
                    if(!this._canSave) {
                        rs();
                        return;
                    }
                }
                this._saveRequestCount++;
                setTimeout(() => {

                    
                     if(this.canSave)
                     {

                    
                    this.internalSave(force)
                        .then(() => {
                            this._savePromise = undefined;
                            this._canSave = true;
                            rs();
                        })
                        .catch(() => {
                            this._savePromise = undefined;
                            this._canSave = true;
                            rs();
                        });
                    }
                    else
                    {
                        this._savePromise = undefined;
                        this._canSave = true;
                    }
                }, 100);
            });
        this._savePromise
            .then(() => {
                this._savePromise = undefined;
            })
            .catch(() => {
                this._savePromise = undefined;
            });
        return this._savePromise;
    }

    private internalSave(force: boolean = false): Promise<any> {
        return new Promise<any>((rs, rj) => {
            if(this._saveRequestCount == 0 || !this.IsLoged()) {
                rs();
            } else {
                this._canSave = false;

                if(this.loggedIn) {
                    this.beforeSettingsSave();

                    if(this.selectedSet && this.selectedSet !== "") {
                        this.userSetSave(this.selectedSet, force)
                            .then(r => {
                                this._canSave = true;
                                //this.HasChanges = false;
                                this._saveRequestCount = 0;

                                rs();
                            })
                            .catch(error => {
                                rj(error);
                            });
                        return;
                    } else {
                        this._canSave = true;
                        //this.HasChanges = false;
                        this._saveRequestCount = 0;
                        rs();
                    }
                } else {
                    this._canSave = true;
                    //this.HasChanges = false;
                    this._saveRequestCount = 0;
                    rs();
                }
            }
        });
    }

    private beforeSettingsSave() {
        Object.keys(this.charts).forEach(chartId => {

            if(this.loadedChartData)
            {
                let chart = this.charts[chartId];
                if(chart == null || chart.instance == null) return;
                var json = this.charts[chartId].toJson();
                // if(chartId=="ach1")debugger;
                this.setToUserStore(`chart-${ chartId }-cfg`, json);
                this.charts[chartId]!.instance!.saveUserIndicators();
            }
         


        });
        this.setToUserStore("landingPageClickState", JSON.stringify(this.landingPageClickState))
        this.setToUserStore("userSets", JSON.stringify(this.userSets));
        this.setToUserStore(`workspace-displayMode`, this.chartDisplayMode);
        this.setToUserStore(`mobileView`, this.mobileView);
        this.setToUserStore(`userIndicators`, JSON.stringify(this.userIndicators));
        this.setToUserStore(`baskets`, JSON.stringify(this._baskets));
        this.setToUserStore(`activeBasket`, this.activeBasket.toString());
        this.setToUserStore(`activeSymbolType`, this.activeSymbolType);
        this.setToUserStore(`showQuotePanel`, this.showQuotePanel ? "1" : "0");
        this.setToUserStore(`lineThickness`, String(this.lineThickness));
        this.setToUserStore(`fillColor`, String(this.fillColor));
        this.setToUserStore(`strokeColor`, String(this.strokeColor));
        this.setToUserStore(`showTradeDesk`, this.showTradeDesk ? "1" : "0");
        this.setToUserStore(`quoteDisplayMode`, this.quoteDisplayMode.toString());
        this.setToUserStore(`activeTab`, this.activeTab);
        this.setToUserStore(`displayModeForChartDisplayMode`, JSON.stringify(this.displayModeForChartDisplayMode));
        this.setToUserStore(
            `prevDisplayModeForChartDisplayMode`,
            JSON.stringify(this.prevDisplayModeForChartDisplayMode)
        );
        this.setToUserStore(`showPeriod`, this.showPeriod ? "1" : "0");
        this.setToUserStore(`showCurrentRate`, this.showCurrentRate ? "1" : "0");
        this.setToUserStore(`lockAllCharts`, this.lockAllCharts ? "1" : "0");
        this.setToUserStore(`layoutMode`, this.layoutMode);
        this.setToUserStore(`tradeDeskHeight`, this.tradeDeskHeight.toString());
        this.setToUserStore(`lastTradeInformations`, this.lastTradeInformations);
        this.setToUserStore(`orderGridColumnsState`, this.orderGridColumnsState);
        this.setToUserStore(`historyGridColumnsState`, this.historyGridColumnsState);
        this.setToUserStore(`lockTradeDesk`, this.lockTradeDesk ? "1" : "0");
        this.setToUserStore("symbolOneClicks", JSON.stringify(this.SymbolOneClicks));
        this.setToUserStore("activeAccountIdBySet", this.activeAccountIdBySet.toString());
        this.setToUserStore("watchedVideos", JSON.stringify(this.watchedVideos));
        this.setToUserStore("userTemplates", JSON.stringify(this.userTemplates));
        this.setToUserStore("savedScans", JSON.stringify(this.savedScans));
        this.setToUserStore("savedScansOnePool", JSON.stringify(this.savedScansOnePool));
    }

    public get displayModeForChartDisplayMode(): IdisplayModeForChartDisplayMode {
        return this._displayModeForChartDisplayMode;
    }
    public set displayModeForChartDisplayMode(value: IdisplayModeForChartDisplayMode) {
        let oldVal = JSON.stringify(this.displayModeForChartDisplayMode);
        let newVal = JSON.stringify(value);
        this.setHasChanges(oldVal == newVal, () => {
            this._displayModeForChartDisplayMode = value;
        });
    }

    //  private _prevDisplayModeForChartDisplayMode: IdisplayModeForChartDisplayMode={};
    public get prevDisplayModeForChartDisplayMode(): IdisplayModeForChartDisplayMode {
        return this._prevDisplayModeForChartDisplayMode;
    }
    public set prevDisplayModeForChartDisplayMode(value: IdisplayModeForChartDisplayMode) {
        let oldVal = JSON.stringify(this.prevDisplayModeForChartDisplayMode);
        let newVal = JSON.stringify(value);

        this.setHasChanges(oldVal == newVal, () => {
            this._prevDisplayModeForChartDisplayMode = value;
        });
    }

    public currentSettings: {[key: string]: Setting} = {}; // Setting[] = [];
    public notUserSetSettings: string[] = [
        "userSets",
        "selectedSet",
        "userIndicators",
        "baskets",
        "symbolOneClicks",
        "watchedVideos",
        "userTemplates",
        "savedScans",
        "savedScansOnePool",
    ];

    public isUserSetSetting(s: string): boolean {
        return !(this.notUserSetSettings.indexOf(s) >= 0);
    }

    public getCurrentSettingsAsArray(): Setting[] {
        return Object.keys(this.currentSettings).map(x => {
            let cloned = this.currentSettings[x].clone();
            return cloned;
        });
    }

    public setSymbolOneClick(symbol: string, enabled: boolean, volume: number, label: string) {
        this.SymbolOneClicks[symbol] = {
            enabled: enabled,
            volume: volume,
            label: label
        };
        this.setChangedProperty("SymbolOneClicks", true);
        this.save();
    }

    public setToUserStore(name: string, value: string) {
        // var userName = this.getCurrentUserName() || "";
        //if (userName != "") {
        // TODO: remove localstorage
        //      localStorage.setItem(`${userName}-${name}`, value);

        var s = this.currentSettings[name] || new Setting();
        s.key = name;
        this.setChangedProperty(s.key, s.setting1 != value);
        s.setting1 = value;
        this.currentSettings[name] = s;
        //}
    }

    public getFromUserStore(name: string, defaultValue?: string | null): string | null {
        //var userName = this.getCurrentUserName() || "";
        // TODO: remove localstorage
        // var result = localStorage.getItem(`${userName}-${name}`);
        // if (!result && defaultValue) {
        //     result = defaultValue;
        // }

        var s = this.currentSettings[name] || new Setting();
        s.key = name;
        s.setting1 = s.setting1 || defaultValue;
        this.currentSettings[name] = s;

        return s.setting1 || null;
    }

    private _loadSettingsPrommise?: Promise<Setting[]>;

    public load(): Promise<Setting[]> {
        this._loadRequestCount++;
        this._canSave = false;
        this._loadSettingsPrommise =
            this._loadSettingsPrommise ||
            new Promise<Setting[]>((rs, rj) => {
                setTimeout(() => {
                    this.internalLoad()
                        .then(r => {
                            rs(r);
                        })
                        .catch(e => {
                            console.error(e);
                        });
                }, 100);
            });
        return this._loadSettingsPrommise;
    }

    public loadUserIndicatorsSet(): Promise<Setting | null> {
        return new Promise<Setting | null>((rs, rj) => {
            this.settingsClient
                .get(this.getCurrentUserName(), "userIndicators")
                .toPromise()
                .then(s => {
                    if(s && s.key) {
                        this.setToUserStore(s.key, s.setting1 || "");
                        this.userIndicators = JSON.parse(s.setting1 || "");
                        this.setToUserStore(s.key, s.setting1 || "");
                        this.setChangedProperty(s.key, false);
                    }
                    rs(s);
                })
                .catch(error => {
                    rj(error);
                });
        });
    }

    public loadTournaments(): Promise<Tournament[] | null> {
        return new Promise<Tournament[] | null>((rs, rj) => {
            this.tournamentClient
                .getAll()
                .toPromise()
                .then(s => {
                    rs(s);
                })
                .catch(error => {
                    rj(error);
                });
        });
    }

    public getTournamentsForUser(userId: number): Promise<UserTournamentsResponse | null> {
        return new Promise<UserTournamentsResponse | null>((rs, rj) => {
            this.tournamentClient
                .getTournamentsForUser(userId)
                .toPromise()
                .then(s => {
                    rs(s);
                })
                .catch(error => {
                    rj(error);
                });
        });
    }

    public getStateLoginTournamentsForUser(
        userId: number,
        tournamentId: number
    ): Promise<TournamentUserAndAccount[] | null> {
        return new Promise<TournamentUserAndAccount[] | null>((rs, rj) => {
            this.tournamentClient
                .getlogisState(userId, tournamentId)
                .toPromise()
                .then(s => {
                    rs(s);
                })
                .catch(error => {
                    rj(error);
                });
        });
    }

    public getAllTournamentsForUser(userId: number): Promise<TournamentUserAndAccount[] | null> {
        return new Promise<TournamentUserAndAccount[] | null>((rs, rj) => {
            this.tournamentClient
                .getAllTournamentsForUser(userId)
                .toPromise()
                .then(s => {
                    rs(s);
                })
                .catch(error => {
                    rj(error);
                });
        });
    }

    public deleteTournamentsForUser(userId: number, tournamentId: number): Promise<number | null> {
        return new Promise<number | null>((rs, rj) => {
            this.tournamentClient
                .deleteTournamentUserByIds(userId, tournamentId)
                .toPromise()
                .then(s => {
                    rs(s);
                })
                .catch(error => {
                    rj(error);
                });
        });
    }

    public loadAdvertisements(): Promise<Adveristment[] | null> {
        return new Promise<Adveristment[] | null>((rs, rj) => {
            this.homeClient.adveristment()
                 .toPromise()
                .then(s => {
                    rs(s);
                })
                .catch(error => {
                    rj(error);
                });
        });
    }








    public GetPnLInTimeRange(accountId: number, startDate: moment.Moment, endDate: moment.Moment): Promise<AccountOrderDataSumResponse | null> {
        return new Promise<AccountOrderDataSumResponse | null>((rs, rj) => {
            this.AccountClient
                .getPnLInTimeRange(accountId, startDate, endDate)
                .toPromise()
                .then(s => {
                    rs(s);
                })
                .catch(error => {
                    rj(error);
                });
        });
    }



    public getPnLInTimeRange(accountId: number, startDate: moment.Moment, endDate: moment.Moment) {
        this.GetPnLInTimeRange(accountId, startDate, endDate).then(response => {
            if(response !== null) {
                console.log(response);
            }
        });
    }








    public wasLoginByTournamentUser(userId: number, tournamentId: number, wasLogin: number): Promise<number | null> {
        return new Promise<number | null>((rs, rj) => {
            this.tournamentClient
                .wasFirstLoginUserByIds(userId, tournamentId, wasLogin)
                .toPromise()
                .then(s => {
                    rs(s);
                })
                .catch(error => {
                    rj(error);
                });
        });
    }

    public getTournamentLeaderBoard(tournamentId: number): Promise<LeaderBoardResponse | null> {
        return new Promise<LeaderBoardResponse | null>((rs, rj) => {
            this.tournamentClient
                .getTournamentLeaderboard(tournamentId)
                .toPromise()
                .then(s => {
                    rs(s);
                })
                .catch(error => {
                    rj(error);
                });
        });
    }

    public loadAccounts(email: string): Promise<Account[] | null> {
        return new Promise<Account[] | null>((rs, rj) => {
            this.AccountsClient.getAllByEmail(email)
                .toPromise()
                .then(s => {
                    rs(s);
                })
                .catch(error => {
                    rj(error);
                });
        });
    }

    public deleteAccount(accountId: number): Promise<number> {
        return new Promise<number>((rs, rj) => {
            this.AccountsClient.deleteAccountByAccountId(accountId)
                .toPromise()
                .then(s => {
                    rs(s);
                })
                .catch(error => {
                    rj(error);
                });
        });
    }

    private _usersetList: any;
    public get usersetList(): any {
        return this._usersetList || [];
    }
    public set usersetList(value: any) {
        this._usersetList = value;
    }

    public loadUserSets(): Promise<Setting | null> {
        return new Promise<Setting | null>((rs, rj) => {
            this.settingsClient
                .get(this.getCurrentUserName(), "userSets")
                .toPromise()
                .then(s => {
                    if(s && s.key) {
                        this.setToUserStore(s.key, s.setting1 || "");
                        this.userSets = JSON.parse(s.setting1 || "");
                    }

                    this.validateUserSets();

                    let source = this.userSets;

                    if(this.mobileMode != "desktop") {
                        this.usersetList = Object.keys(this.userSets)
                            .filter(v => {
                                if(v.substr(0, 1) == "m") {
                                    return v;
                                }
                            })
                            .map(function(name) {
                                return {
                                    id: name,
                                    name: source[name]
                                };
                            });
                    } else {
                        this.usersetList = Object.keys(this.userSets)
                            .filter(v => {
                                if(v.substr(0, 1) != "m") {
                                    return v;
                                }
                            })
                            .map(function(name) {
                                return {
                                    id: name,
                                    name: source[name]
                                };
                            });
                    }

                    rs(s);
                })
                .catch(error => {
                    rj(error);
                });
        });
    }

    public userSetload(userSet: string): Promise<Setting[]> {
        // debugger;
        return new Promise<Setting[]>((rs, rj) => {
            this.loadGlobalSettings()
                .then(r => {
                    this.settingsClient
                        .getAllFromSet(this.getCurrentUserName(), userSet)
                        .toPromise()
                        .then(settings => {
                            if(settings) {
                                settings
                                    // filterout global settings
                                    .filter(s => this.notUserSetSettings.indexOf(s.key || "") < 0)
                                    .forEach(s => {
                                        if(s.key) {
                                            this.setToUserStore(s.key, s.setting1 || "");
                                        }
                                    });
                                this.afterUserSetLoaded();
                            }
                            rs(settings || []);
                        })
                        .catch(error => {
                            rj(error);
                        });
                })
                .catch(error => {
                    rj(error);
                });
        });
    }

    public getUserProviders(userId: number): Promise<Setting[]> {
        return new Promise<Setting[]>((rs, rj) => {
            this.settingsClient
                .getProviders(userId)
                .toPromise()
                .then(providers => {

                    rs(providers || []);
                })
                .catch(error => {
                    rj(error);
                });
        });
    }


    public AddProviderLoginData(userId: number, providerId: string, userName: string, userPassword: string | null): Promise<Setting[]> {
        return new Promise<Setting[]>((rs, rj) => {
            this.settingsClient
                .addProviderLoginData(userId, providerId, userName, userPassword)
                .toPromise()
                .then(providers => {
                    rs();
                })
                .catch(error => {
                    rj(error);
                });
        });
    }

    public UpdateProviderLoginData(userId: number, userName: string, userPassword: string | null, providerId: string): Promise<Setting[]> {
        return new Promise<Setting[]>((rs, rj) => {
            this.settingsClient
                .updateProviderLoginData(userId, userName, userPassword, providerId)
                .toPromise()
                .then(providers => {
                    rs();
                })
                .catch(error => {
                    rj(error);
                });
        });
    }






    public loadGlobalSettings(): Promise<Setting[]> {
        return new Promise<Setting[]>((rs, rj) => {
            this.settingsClient
                .getAll(this.getCurrentUserName(), [
                    "baskets",
                    "userIndicators",
                    "watchedVideos",
                    "userTemplates",
                    "savedScans",
                    "savedScansOnePool"
                ])
                .toPromise()
                .then(settings => {
                    if(settings) {
                        settings.forEach(s => {
                            if(s.key) {
                                this.setToUserStore(s.key, s.setting1 || "");
                            }
                        });
                    }
                    rs(settings || []);
                })
                .catch(error => {
                    rj(error);
                });
        });
    }

    public saveUserStrategiesIndicators(): Promise<any> {
        return new Promise<any>((rs, rj) => {
            var setting = new Setting();
            setting.key = "userIndicators";
            setting.setting1 = JSON.stringify(this.userIndicators);

            var settings: Setting[] = [setting];
            this.settingsClient
                .save(this.getCurrentUserName(), JSON.stringify(settings))
                .toPromise()
                .then(response => {
                    this.setChangedProperty("userIndicators", false);
                    rs(response);
                })
                .catch(error => {
                    rj(error);
                });
        });
    }

    public userSetSave(userSet: string, force: boolean = false): Promise<any> {
        this.beforeSettingsSave();
        var result = new Promise<any>((rs, rj) => {
            if(this.userSets[userSet]) {
                let settings = this.getCurrentSettingsAsArray().filter(
                    x => this.serverSettingsKeys.indexOf(x.key || "") >= 0
                );

                settings = force ? settings : settings.filter(x => this.isChanged(x.key || ""));
                settings.forEach(cloned => {
                    if(this.isUserSetSetting(cloned.key || "")) {
                        cloned.key = `${ cloned.key }-${ userSet }`;
                    }
                    return cloned;
                });
                if(settings.length > 0) {
                    this.settingsClient
                        .save(this.getCurrentUserName(), JSON.stringify(settings))
                        .toPromise()
                        .then(response => {
                            this.resetChanges();
                            rs(response);
                        })
                        .catch(error => {
                            rj(error);
                        });
                } else {
                    rs("ok");
                }
            } else {
                let settings = this.getCurrentSettingsAsArray().filter(
                    x => this.serverSettingsKeys.indexOf(x.key || "") >= 0
                );

                settings = force ? settings : settings.filter(x => this.isChanged(x.key || ""));
                settings = settings.filter(cloned => !this.isUserSetSetting(cloned.key || ""));
                if(settings.length > 0) {
                    this.settingsClient
                        .save(this.getCurrentUserName(), JSON.stringify(settings))
                        .toPromise()
                        .then(response => {
                            this.resetChanges();
                            rs(response);
                        })
                        .catch(error => {
                            rj(error);
                        });
                } else {
                    rs("ok");
                }
            }
        });

        return result;
    }

    private internalLoad(): Promise<Setting[]> {
        return new Promise<Setting[]>((rs, rj) => {
            if(this._loadRequestCount == 0) {
                rs(this.getCurrentSettingsAsArray());
            } else {
                try {
                    if(this.IsLoged()) {
                        var un = sessionStorage.getItem("userName") || "";
                        sessionStorage.setItem("userName", "");

                        let sets = this.getFromUserStore("userSets");
                        sessionStorage.setItem("userName", un);

                        if(sets) {
                            this.userSets = JSON.parse(sets);
                        }

                        this.validateUserSets();

                        //   this.selectedSet = sessionStorage.getItem("selectedSet"); //|| localStorage.getItem("selectedSet") || "";

                        if(this.selectedSet == "" || Object.keys(this.userSets).indexOf(this.selectedSet || "") < 0) {
                            this.selectedSet = this.selectedSet || Object.keys(this.userSets)[0];
                        }

                        this.selectedSet = this.selectedSet || Object.keys(this.userSets)[0];

                        if(this.mobileMode == "desktop") {
                            if(this.selectedSet.substr(0, 1) == "m") {
                                let firstDestopSet = Object.keys(this.userSets).filter(v => {
                                    return v.substr(0, 1) != "m";
                                });

                                this.selectedSet = firstDestopSet[0];
                            }
                        }

                        if(
                            Object.keys(this.userSets).indexOf(this.selectedSet) < 0 &&
                            Object.keys(this.userSets).length > 0
                        ) {
                            this.selectedSet = Object.keys(this.userSets)[0];
                        }

                        this.userSetload(this.selectedSet)
                            .then(settings => {
                                rs(this.getCurrentSettingsAsArray());
                                this._loadRequestCount = 0;
                                this._canSave = true;
                            })
                            .catch(error => {
                                rj(error);
                                this._loadRequestCount = 0;
                                this._canSave = true;
                            });
                    } else {
                        rs(this.getCurrentSettingsAsArray());
                        this._loadRequestCount = 0;
                        this._canSave = true;
                    }
                } catch(error) {
                    rj(error);
                    this._loadRequestCount = 0;
                    this._canSave = true;
                }
            }
        });
    }

    public serverSettingsKeys: string[] = [
        "userSets",
        "userIndicators",
        "chart-ach1-cfg",
        "chart-ach2-cfg",
        "chart-ach3-cfg",
        "chart-ach4-cfg",
        "workspace-displayMode",
        "landingPageClickState",
        "baskets",
        "mobileView",
        "activeSymbolType",
        "activeBasket",
        "showTradeDesk",
        "showPeriod",
        "showCurrentRate",
        "lockAllCharts",
        "activeTab",
        "displayModeForChartDisplayMode",
        "prevDisplayModeForChartDisplayMode",
        "chartIndicators_ach1",
        "chartIndicators_ach2",
        "chartIndicators_ach3",
        "chartIndicators_ach4",
        "wizIndicators_ach1",
        "wizIndicators_ach2",
        "wizIndicators_ach3",
        "wizIndicators_ach4",
        "symbolOneClicks",
        "showtradeLines",
        "showIndicatorLines",
        "tradeDeskHeight",
        "historyGridColumnsState",
        "orderGridColumnsState",
        "lockTradeDesk",
        "activeAccountIdBySet",
        "lastTradeInformations",
        "watchedVideos",
        "userTemplates",
        "savedScans",
        "savedScansOnePool",
        "showQuotePanel",
        "lineThickness",
        "fillColor",
        "strokeColor"
    ];

    private _loadedChartData: boolean = false;
    public get loadedChartData(): boolean {
        return this._loadedChartData;
    }
    public set loadedChartData(value: boolean) {
        this._loadedChartData = value;
    }
    public canLoadChartData: boolean = false;

    private _activeAdvertisements: Adveristment[] = [];
    public get activeAdvertisements(): Adveristment[] {
        return this._activeAdvertisements;
    }
    public set activeAdvertisements(value: Adveristment[]) {
        this._activeAdvertisements = value;
    }
    public isActiveAdvertisement:boolean = false;
    private _minAdvHeigh: any = "";
    public get minAdvHeigh(): any {


        return {
            "min-height": this._minAdvHeigh
        }; ;

        
    }
    public set minAdvHeigh(value: any) {
        this._minAdvHeigh = value;
    }
    public afterUserSetLoaded(): Promise<void> {
        return new Promise<void>((rs, rj) => {
            // var lcs = this.getFromUserStore("landingPageClickState");
            // if(lcs) {
            //     console.log('set from state 1', JSON.parse(lcs));
            //     this.landingPageClickState = <landingClickState> JSON.parse(lcs);
            // }

            let txt = this.getFromUserStore(`userIndicators`);
            if(txt && txt != "") {
                try {
                    this.userIndicators = JSON.parse(txt);
                } catch(ex) {}
            }

            this.loadAdvertisements().then(advertisements=>{

            console.log("ADVERTISEMENTS");
            console.log(advertisements);

            if(advertisements)
           { 
               this.activeAdvertisements = advertisements;
               if(this.activeAdvertisements.length>0)
               {
                   this.isActiveAdvertisement = true;
                   this.showSLider = true;
               }
            }

            this.loadTournamentAndSetUser().then(() => {
                this.getAllTournaments();

                this.dataService.chartRequestsCount = 0;



                var dm = this.getRouterDisplayMode() || this.getFromUserStore(`workspace-displayMode`);
                if(dm && dm != "") {
                    this.chartDisplayMode = <ChartDisplayMode> dm;
                    callNextAsync(this.chartDisplayModeService.subscriber, this.chartDisplayMode);
                }

                var mobileView = this.getFromUserStore("mobileView");
                if(mobileView) {
                    console.log('set mobile view');
                    this.mobileView = <MobileMainView> mobileView;
                }

                var baskets = this.getFromUserStore(`baskets`);
                if(baskets && baskets != "") {
                    this._baskets = JSON.parse(baskets);
                }

                const watchedVideos = this.getFromUserStore("watchedVideos");
                if(watchedVideos != null) this.watchedVideos = JSON.parse(watchedVideos);
                this.setChangedProperty("watchedVideos", false);

                const userTemplates = this.getFromUserStore("userTemplates");
                if(userTemplates != null) this.userTemplates = JSON.parse(userTemplates);
                this.setChangedProperty("userTemplates", false);

                const savedScans = this.getFromUserStore("savedScans");
                if(savedScans != null) this.savedScans = JSON.parse(savedScans);
                this.setChangedProperty("savedScans", false);

                const savedScansOnePool = this.getFromUserStore("savedScansOnePool");
                if(savedScansOnePool != null) this.savedScansOnePool = JSON.parse(savedScansOnePool);
                this.setChangedProperty("savedScansOnePool", false);


                var lcs = this.getFromUserStore("landingPageClickState");
                if(lcs) {
                    console.log('set from state 1', JSON.parse(lcs));
                    this.landingPageClickState = <landingClickState> JSON.parse(lcs);
                }

                var abs = this.getFromUserStore(`activeBasket`);
                var ab = Number(abs);
                this.activeBasket = isNaN(ab) ? -1 : ab;

                var st = this.getRouterSymbolType() || this.getFromUserStore(`activeSymbolType`);
                if(st && st != "") {
                    this.activeSymbolType = <SymbolTypeEnum> st;
                }
                var sqp = this.getFromUserStore(`showQuotePanel`) || "1";

                this.showQuotePanel = sqp == "1";
                this.showTradeDesk = this.getFromUserStore(`showTradeDesk`) == "1";
                this.showPeriod = this.getFromUserStore(`showPeriod`, "0") == "1";
                this.showCurrentRate = this.getFromUserStore(`showCurrentRate`, "1") == "1";
                this.lockAllCharts = this.getFromUserStore(`lockAllCharts`, "1") == "1";

                this.showtradeLines = this.getFromUserStore(`showtradeLines`, "1") == "1";

                this.tradeDeskHeight = Number(this.getFromUserStore("tradeDeskHeight", "400"));
                this.lineThickness = Number(this.getFromUserStore("lineThickness", "2"));

                if((this.getFromUserStore("fillColor", "")!=null))
                {
                      this.fillColor = String(this.getFromUserStore("fillColor", ""));
                }

                if((this.getFromUserStore("fillColor", "")!=null))
                {
                    this.strokeColor = String(this.getFromUserStore("strokeColor", ""));
                }
              
                this.lastTradeInformations = String(this.getFromUserStore("lastTradeInformations", ""));

                this.historyGridColumnsState = String(this.getFromUserStore("historyGridColumnsState", "noSave"));
                this.orderGridColumnsState = String(this.getFromUserStore("orderGridColumnsState", "noSave"));

                // this.loadTournamentAndSetUser();

                // this.getAllTournaments();

                this.lockTradeDesk = this.getFromUserStore(`lockTradeDesk`, "1") == "1";

                var dmn = Number(this.getFromUserStore(`quoteDisplayMode`));

                this.quoteDisplayMode = isNaN(dmn) || dmn == 0 ? 1 : dmn;
                var at = this.getRouterActiveTab()  || this.getFromUserStore(`activeTab`) || QuotePanelsTabsList.SYMBOL;
                //this.activeTab=at;
                //debugger;
                this.activeTab = at && at != "" ? <QuotePanelsTabsList> at : QuotePanelsTabsList.SYMBOL;

                this.SymbolOneClicks = JSON.parse(this.getFromUserStore("symbolOneClicks", "{}") || "{}");
                // load 1-clisk state
                this.boxes.forEach((item, index) => {
                    item.init1Click();
                });

                var dmfc = this.getFromUserStore(`displayModeForChartDisplayMode`);
                if(dmfc && dmfc != "") {
                    this.displayModeForChartDisplayMode = <IdisplayModeForChartDisplayMode> JSON.parse(dmfc);
                }
                var pmfc = this.getFromUserStore(`prevDisplayModeForChartDisplayMode`);
                if(pmfc && pmfc != "") {
                    this.prevDisplayModeForChartDisplayMode = <IdisplayModeForChartDisplayMode> JSON.parse(pmfc);
                }

                this.resetChanges();

                callNextAsync(this.chartDisplayModeService.subscriber, this.chartDisplayMode).then(() => {
                    callNextAsync(
                        this.activeLayoutTypeService.subscriber,
                        this.displayModeForChartDisplayMode[this.chartDisplayMode]
                    ).then(() => {
                        this.emitBasketChange(this.activeBasket).then(() => {
                            rs();
                        });
                    });
                });
                if(!this.canLoadChartData) {

                    if(this.charts['ach1'].instance) {
                        this.charts['ach1'].instance.symbol = this.charts['ach1'].Symbol;
                        this.charts['ach1'].instance.period = this.charts['ach1'].Period[this.charts['ach1'].DisplayMode];
                    }
                    if(this.charts['ach2'].instance) {
                        this.charts['ach2'].instance.symbol = this.charts['ach2'].Symbol;
                        this.charts['ach2'].instance.period = this.charts['ach2'].Period[this.charts['ach2'].DisplayMode];

                    }
                    if(this.charts['ach3'].instance) {
                        this.charts['ach3'].instance.symbol = this.charts['ach3'].Symbol;
                        this.charts['ach3'].instance.period = this.charts['ach3'].Period[this.charts['ach3'].DisplayMode];

                    }
                    if(this.charts['ach4'].instance) {
                        this.charts['ach4'].instance.symbol = this.charts['ach4'].Symbol;
                        this.charts['ach4'].instance.period = this.charts['ach4'].Period[this.charts['ach4'].DisplayMode];
                    }


                    this.canLoadChartData = true;


                    if(this.charts['ach1'].instance) {
                        this.charts['ach1'].instance.refreshPeriod();
                    }
                    if(this.charts['ach2'].instance) {
                        this.charts['ach2'].instance.refreshPeriod();
                    }
                    if(this.charts['ach3'].instance) {
                        this.charts['ach3'].instance.refreshPeriod();
                    }
                    if(this.charts['ach4'].instance) {
                        this.charts['ach4'].instance.refreshPeriod();
                    }
                }

                
                if(this.currentProvider == Providers.OANDA && this.accounts.length > 0) {
                    let active = this.accounts[0]
                    if(active) {
                 //       this.activeAccountId = active.id;
                        this.activeAccountIdBySet = active.id;
                    }
                    else {
                 //       this.activeAccountId = 0;
                        this.activeAccountIdBySet = 0;
                    }
                }
                this.canSave = true;

            });
        })



        });
    }

    private _activeTournamentAccountId: number = -1;
    public get activeTournamentAccountId(): number {
        return this._activeTournamentAccountId;
    }
    public set activeTournamentAccountId(value: number) {
        this._activeTournamentAccountId = value;
    }

    private _firstLoginAllowed: TournamentWithAccountId | undefined;
    public get firstLoginAllowed(): TournamentWithAccountId | undefined {
        return this._firstLoginAllowed;
    }
    public set firstLoginAllowed(value: TournamentWithAccountId | undefined) {
        this._firstLoginAllowed = value;
    }

    public getFirstChallenge: TournamentWithAccountId | undefined;
    public challengeWithUser: boolean = false;
    public loadTournamentAndSetUser(): Promise<any> {
        return new Promise<any>((rs, rj) => {
            this.getTournamentsForUser(this.userId)
                .then(response => {
                    // after some time alow to send requests for historical data

                    if(response !== null) {
                        this.tournamentsWithoutUser = response.tournamentWithoutAccount; //!.slice(0,1 );
                        this.tournamentsWithUser = response.tournamentWithAccount; //!.slice(0, 1);

                        if(this.tournamentsWithUser!.length > 0) {
                            this.getFirstChallenge = this.tournamentsWithUser![0];
                            this.challengeWithUser = true;
                        } else {
                            if(this.tournamentsWithoutUser!.length > 0) {
                                this.getFirstChallenge = this.tournamentsWithoutUser![0];
                                this.challengeWithUser = false;
                            }
                        }

                        //let activeTOurnamentsAccountList

                        //  this.accounts

                        let activeTournamentsAccount: number[] = [];

                        if(this.activeTournaments) {
                            activeTournamentsAccount = this.activeTournaments.map(v => {
                                return v.accountId;
                            });
                        }

                        //  let  mapUnactiveChallengeUsers:(number | undefined)[] =[];
                        if(this.tournamentsWithUser) {
                            this.mapUnactiveChallengeUsers = this.tournamentsWithUser.map(v => {
                                if(activeTournamentsAccount.indexOf(v.accountId) < 0) {
                                    return v.accountId;
                                }
                            });
                        }

                        if(this.mapUnactiveChallengeUsers.length > 0) {
                            this.accounts = this.accounts.filter(v => {
                                return this.mapUnactiveChallengeUsers.indexOf(v.id) < 0;
                                // return true;
                            });
                        }

                        if(this.currentProvider == Providers.DEMO) {


                            if(this.activeTournaments!.length > 0) {
                                let tournamentAccountId = this.activeTournaments![0].accountId;

                                this.activeAccountIdBySet = tournamentAccountId;
                                this.activeTournamentAccountId = tournamentAccountId;

                                this.loadLeaderBoards();
                            } else {
                                let accountToSet = Number(
                                    this.getFromUserStore("activeAccountIdBySet", this.mainAccountId.toString())
                                );

                                if(this.mapUnactiveChallengeUsers.indexOf(accountToSet) > -1) {
                                    this.activeAccountIdBySet = this.mainAccountId;
                                } else {
                                    this.activeAccountIdBySet = Number(
                                        this.getFromUserStore("activeAccountIdBySet", this.mainAccountId.toString())
                                    );
                                }
                            }
                        }
                        this.sendPreviousChallengesRequest();

                        this.dataService.waitingForUserAccountCompleteInfo = false;

                        setTimeout(() => {
                            this.dataService.canSendRequest = true;
                            Object.keys(this.charts).forEach(chartId => {
                                var json = this.getFromUserStore(`chart-${ chartId }-cfg`);
                                if(json && json != "") {

                                    this.charts[chartId].fromJson(json);

                                    let findSymbol = this.providerInstruments.find(v => v.Symbol == this.charts[chartId].Symbol);
                                    if(findSymbol == undefined && this.providerInstruments.length > 0) {

                                        let mapInit = this.boxes.map(v => {
                                            return v.Symbol
                                        });
                                        let mapProvider = this.providerInstruments.map(v => {return v.Symbol});

                                        let intersction = mapInit.filter(l => -1 !== mapProvider.indexOf(l))


                                        this.charts[chartId].Symbol = intersction[0];
                                    }

                                }

                                if(this.charts[chartId].instance !== undefined) {
                                    if(this.competitionAccountList.indexOf(this.activeAccountIdBySet) > -1) {
                                        this.activeSymbolType = SymbolTypeEnum.Forex;

                                        let filter = this.boxes.filter(v => {
                                            return v.Symbol == this.charts[chartId].Symbol;
                                        });

                                        if(filter[0].Type == SymbolTypeEnum.Forex) {
                                            this.charts[chartId]!.instance!.onSelectNewSymbol(this.charts[chartId].Symbol);
                                        } else {
                                            const firstBox = this.boxes.find(b => b.searchVisible && b.visible);
                                            if(firstBox) {
                                                this.charts[chartId]!.instance!.onSelectNewSymbol(firstBox.Symbol);
                                            }
                                        }

                                        //         debugger;
                                        //    this.charts[chartId]!.instance!.loadUserIndicators();
                                    } else {
                                        this.charts[chartId]!.instance!.onSelectNewSymbol(this.charts[chartId].Symbol);
                                    }
                                }
                            });
                            this.loadedChartData = true;
                        }, 10);
                    } else {
                        this.activeAccountIdBySet = Number(
                            this.getFromUserStore("activeAccountIdBySet", this.mainAccountId.toString())
                        );

                        Object.keys(this.charts).forEach(chartId => {
                            var json = this.getFromUserStore(`chart-${ chartId }-cfg`);
                            if(json && json != "") {
                                this.charts[chartId].fromJson(json);
                            }

                            if(this.charts[chartId].instance !== undefined) {
                                this.charts[chartId]!.instance!.loadUserIndicators();

                                if(this.competitionAccountList.indexOf(this.activeAccountIdBySet) > -1) {
                                    this.charts[chartId]!.instance!.onSelectNewSymbol("EUR/CAD");
                                } else {
                                    this.charts[chartId]!.instance!.onSelectNewSymbol(this.charts[chartId].Symbol);
                                }
                            }
                        });
                    }
                    rs()
                })
                .catch(error => {
                    this.activeAccountIdBySet = Number(
                        this.getFromUserStore("activeAccountIdBySet", this.mainAccountId.toString())
                    );
                    rs();
                });
        });
    }

    private _mapUnactiveChallengeUsers: (number | undefined)[] = [];
    public get mapUnactiveChallengeUsers(): (number | undefined)[] {
        return this._mapUnactiveChallengeUsers;
    }
    public set mapUnactiveChallengeUsers(value: (number | undefined)[]) {
        this._mapUnactiveChallengeUsers = value;
    }

    private _currentTournaments: Tournament[] = [];
    public get currentTournaments(): Tournament[] {
        return this._currentTournaments;
    }
    public set currentTournaments(value: Tournament[]) {
        this._currentTournaments = value;
    }

    private _lastTournaments: Tournament[] = [];
    public get lastTournaments(): Tournament[] {
        return this._lastTournaments;
    }
    public set lastTournaments(value: Tournament[]) {
        this._lastTournaments = value;
    }

    private _upcomingTournaments: Tournament[] = [];
    public get upcomingTournaments(): Tournament[] {
        return this._upcomingTournaments;
    }
    public set upcomingTournaments(value: Tournament[]) {
        this._upcomingTournaments = value;
    }

    private _challengeActiveTab: challengeTabsList = challengeTabsList.ACTIVE;
    public get challengeActiveTab(): challengeTabsList {
        return this._challengeActiveTab;
    }
    public set challengeActiveTab(value: challengeTabsList) {
        this._challengeActiveTab = value;
    }

    private _showSLider: boolean = false;
    public get showSLider(): boolean {
        return this._showSLider;
    }
    public set showSLider(value: boolean) {
        this._showSLider = value; 
    }

    public getAllTournaments() {
        this.loadTournaments().then(response => {
            //
            if(response !== null) {
                let today = moment().utc();

                this.currentTournaments = response.filter(v => {
                    return today.isBetween(v.startDateUtc, v.endDateUtc);
                });

                this.lastTournaments = response.filter(v => {
                    let dt = moment(v.endDateUtc).add(30, "days");
                    return today.isBetween(v.endDateUtc, dt);
                });

                this.upcomingTournaments = response.filter(v => {
                    return today.isSameOrBefore(v.startDateUtc);
                });

                if(this.upcomingTournaments.length > 0) {
                    this.showSLider = true;
                }

                let canShowList = response.filter(v=>{
                        return  today.isBetween(v.startAdvertisingDateUtc, v.endAdvertisingDateUtc,"day","[]")
                })

                if(canShowList.length>0)
                {
                    this.showSLider = true;
                }
                // if( this.activeTournaments!== undefined &&  this.activeTournaments!== null)
                // {
                //     let Id = this.activeTournaments[0].id

                //             this.currentTournaments.filter(v=>{
                //                    return v.id == Id
                //             })

                // }
                //  debugger;

                if(this.currentProvider == Providers.DEMO) {

                    this.allowedForexSymbols = allowedForexSymbols;

                    if(this.currentTournaments.length > 0) {
                        if(
                            this.currentTournaments[0].symbolList !== undefined &&
                            this.currentTournaments[0].symbolList !== null
                        ) {
                            if(this.currentTournaments[0].symbolList.symbolListSymbol) {
                                let symbols = this.currentTournaments[0].symbolList.symbolListSymbol.map(v => {
                                    return v.symbol;
                                });
                                //   debugger;

                                this.allowedForexSymbols = symbols as string[];

                                this.globaGridMode.changeActiveBasket.next(this.activeBasket);
                            }
                        }
                    }
                }
                else {
                    if(this.providerInstruments.length > 0) {
                        let symbols = this.providerInstruments.map(v => {
                            return v.Symbol
                        });

                        this.allowedForexSymbols = symbols;
                        this.globaGridMode.changeActiveBasket.next(this.activeBasket);
                    }

                }

                callNextAsync(this.globaGridMode.loadedTournaments, true);
            }
        });
    }

    public allTournamentsAccounts: TournamentUserAndAccount[] = [];

    public getAllAccountsForUserById(id: number): Promise<any> {
        return new Promise<any>((rs, rj) => {
            this.getAllTournamentsForUser(id).then(response => {
                if(response !== null) {
                    // console.log("getAllAccountsForUserById");
                    //  console.log(response);
                    this.allTournamentsAccounts = response;
                    let today = moment().utc();
                    let oldAccounts = this.allTournamentsAccounts.filter(v => {
                        if(v.tournament !== undefined && v.tournament !== null) {
                            let m = moment(v.tournament.endDateUtc.format("YYYY-MM-DD")).add(3, "days");
                            let l = today.isAfter(v.tournament.endDateUtc.add(3, "days"));
                            return l;
                            //  v.tournament.endDateUtc
                        }

                        return false;
                    });

                    let oA = oldAccounts.map(v => {
                        return v.accountId;
                    });

                    this.afterChallengeUsers = oldAccounts.map(v => {
                        return v.accountId;
                    });
                }
                rs();
            });
        });
    }

    public leadeboardList: Leaderboard[] | null | undefined = [];
    public loadLeaderBoards() {
        if(this.activeTournaments!.length > 0) {
            if(this.activeTournaments) {
                let LeaderBoardReq: ILeaderBoardReq = {TournamentId: this.activeTournaments[0].id};

                this.dataService.sendRequest({
                    Cmd: DataService.TYPE_LEADERBOARD,
                    Data: LeaderBoardReq
                });

                this.dataService.dataSubscriber.subscribe(response => {
                    if(response.Type == "LeaderBoardRs") {
                        var leaderBoardResponse: ILeaderBoardRs = <ILeaderBoardRs> response;
                        this.leadeboardList = leaderBoardResponse.ContestantResults.map(v => {
                            let t = new Leaderboard();
                            t.accountId = v.AccountId;
                            t.accountName = v.AccountName;
                            t.pnL = v.PnL;
                            t.place = v.Place;
                            t.isCurrentUser = v.IsCurrentUser;
                            return t;
                        });
                    }
                });
            }
            // this.getTournamentLeaderBoard(this.activeTournaments[0].id)
            // .then(response => {
            //     if (response !== null) {
            //       this.leadeboardList = response.leaderBoardForTournament;

            //     }
            // }).catch(error => {

            // })
            // }
        }
    }

    // public getLoginStateForUserAndTournament()
    // {
    //     this.deleteTournamentsForUser(this.workspace.userId,this.competition!.id)
    //     .then(response => {
    //         if (response !== null) {
    //             this.workspace.loadTournamentAndSetUser();
    //             this.modalService.dismissAll();
    //         }
    //     }).catch(error => {
    //
    //     })
    // }

    public addToBasket(basketId: number, symbol: string) {
        let index = this._baskets[basketId].items.indexOf(symbol);
        if(index < 0) {
            this._baskets[basketId].items.push(symbol);
            this.setChangedProperty("Baskets", true);
            this.emitBasketChange(basketId);
        }
    }

    public removeFromBasket(basketId: number, symbol: string) {
        let index = this._baskets[basketId].items.indexOf(symbol);
        if(index >= -1) {
            this._baskets[basketId].items.splice(index, 1);
            this.setChangedProperty("Baskets", true);
            this.emitBasketChange(basketId);
        }
    }

    public updateBasket(basketId: number, value: string[]): Promise<void> {
        return new Promise<void>((rs, rj) => {
            this._baskets[basketId].items = value;
            this.setChangedProperty("Baskets", true);
            this.emitBasketChange(basketId);
        });
    }

    public getItemsFromBasket(basketId: number): IBasket {
        return this._baskets[basketId];
    }

    public getCountOfBaskets() {
        return this._baskets.length;
    }

    public getActiveBasketItems(): string[] {
        let filtered = this._baskets[this.activeBasket].items
            .filter(v => {
                if(this.mapSymbols.indexOf(v) > -1) {
                    return true;
                }
            })
            .filter(l => {
                if(this.competitionAccountList.indexOf(this.activeAccountIdBySet) > -1 || this.currentProvider != Providers.DEMO) {
                    // console.log(this.workspace.currentTournaments[0].tournamentAssets);

                    if(this.allowedForexSymbols.indexOf(l) > -1) {
                        //&& this.workspace.currentTournaments[0].tournamentAssets.Assets.indexOf(0))
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            });

        return filtered;
    }

    public get mapSymbols() {
        let allSymbols = this.SymbolInfoes.map(vl => {
            return vl.Symbol;
        });
        return allSymbols;
    }

    public getBasketItems(id: number): string[] {
        let filtered = this._baskets[id].items.filter(v => {
            if(this.mapSymbols.indexOf(v) > -1) {
                return true;
            }
        });

        //mapSymbols

        return filtered;
        // .filter((v)=>{
        //     this.getSymbolInfoByName(v).Type!=undefined;
        // });
    }

    public emitBasketChange(v: number, forceSave: boolean = false): Promise<void> {
        return new Promise<void>((rs, rj) => {
            callNextAsync(this.globaGridMode.changeActiveBasket, v).then(() => {
                this.save(forceSave)
                    .then(r => {
                        rs(r);
                    })
                    .catch(e => {
                        rj(e);
                    });
            });
        });
    }

    public addNewSet(setName: string, customSetId?: string) {
        customSetId = customSetId || `${ new Date().getTime() }.${ Math.random() }`;
        this.userSets[customSetId] = setName;
        if(this.selectedSet == "") {
            this.selectedSet = customSetId;
        }
        this.save(true);

        let source = this.userSets;
        this.usersetList = Object.keys(this.userSets).map(function(name) {
            return {
                id: name,
                name: source[name]
            };
        });

        return customSetId;
    }

    public changeSetName(setId: string, setName: string) {
        if(this.userSets[setId] == null) return false;
        this.userSets[setId] = setName;
        this.save(true)
            .then(r => {
                if(setId) {
                    this.userSetSave(setId);
                }
            })
            .catch(e => {
                console.error(e);
            });
        return true;
    }

    private mobileSetId: any;
    public validateUserSets(): Promise<void> {
        return new Promise<void>((rs, rj) => {
            let mobileWithNoSet = false;
            if(this.mobileMode != "desktop") {
                let mobileSetExist = false;
                Object.keys(this.userSets).forEach(key => {
                    if(key.substring(0, 1) == "m") {
                        mobileSetExist = true;
                        this.mobileSetId = key;
                    }
                });

                if(!mobileSetExist) {
                    mobileWithNoSet = true;
                }
            }

            let onlyMobileSet: boolean = false;

            if(this.mobileMode == "desktop" && Object.keys(this.userSets).length == 1) {
                Object.keys(this.userSets).forEach(key => {
                    if(key.substring(0, 1) == "m") {
                        onlyMobileSet = true;
                    }
                });
            }

            if(onlyMobileSet) {
                this.selectedSet = this.addNewSet("Set 1");
            }

            // debugger
            // if (this.mobileMode == "desktop" && this.selectedSet) {

            //         let firstDestopSet = Object.keys(this.userSets).filter(v => {
            //             return v.substr(0, 1) != "m";
            //         })

            //     if (this.selectedSet.substr(0, 1) == "m") {

            //         this.selectedSet = firstDestopSet[0];

            //     }
            //     else
            //     {

            //         let findSelected = Object.keys(this.userSets).filter(v => {
            //             return v == this.selectedSet;
            //         })

            //         if(findSelected.length==0)
            //         {
            //              this.selectedSet = firstDestopSet[0];
            //         }

            //     }
            // }

            if(!this.userSets || Object.keys(this.userSets).length == 0 || mobileWithNoSet) {
                if(this.mobileMode != "desktop") {
                    let setId = `m${ new Date().getTime() }.${ Math.random() }`;
                    this.selectedSet = this.addNewSet("mobile", setId);
                } else {
                    this.selectedSet = this.addNewSet("Set 1");
                }

                if(this.mobileMode != "desktop") {
                    let ach1 = this.charts["ach1"].instance!;
                    ach1.removeAllIndicatorInstances();
                    ach1.removeAllAnnotations();

                    ach1.Config.chartIndicatorInstances = {};
                    ach1.Config.wizardIndicatorInstances = {};
                    Promise.all([ach1.updateChartDisplay(this.chartDisplayMode)])
                        .then(() => {
                            this.save(false);
                            this.userSetSave(this.selectedSet || "");
                            rs();
                        })
                        .catch(e => {
                            console.error(e);
                        });
                } else {
                    let ach1 = this.charts["ach1"].instance!;
                    let ach2 = this.charts["ach2"].instance!;
                    let ach3 = this.charts["ach3"].instance!;
                    let ach4 = this.charts["ach4"].instance!;
                    ach1.removeAllIndicatorInstances();
                    ach2.removeAllIndicatorInstances();
                    ach3.removeAllIndicatorInstances();
                    ach4.removeAllIndicatorInstances();

                    ach1.removeAllAnnotations();
                    ach2.removeAllAnnotations();
                    ach3.removeAllAnnotations();
                    ach4.removeAllAnnotations();

                    ach1.Config.chartIndicatorInstances = {};
                    ach2.Config.chartIndicatorInstances = {};
                    ach3.Config.chartIndicatorInstances = {};
                    ach4.Config.chartIndicatorInstances = {};

                    ach1.Config.wizardIndicatorInstances = {};
                    ach2.Config.wizardIndicatorInstances = {};
                    ach3.Config.wizardIndicatorInstances = {};
                    ach4.Config.wizardIndicatorInstances = {};

                    Promise.all([
                        ach1.updateChartDisplay(this.chartDisplayMode),
                        ach2.updateChartDisplay(this.chartDisplayMode),
                        ach3.updateChartDisplay(this.chartDisplayMode),
                        ach4.updateChartDisplay(this.chartDisplayMode)
                    ])
                        .then(() => {
                            this.save(false);
                            this.userSetSave(this.selectedSet || "");
                            rs();
                        })
                        .catch(e => {
                            console.error(e);
                        });
                }
            } else {
                rs();
            }
        });
    }

    public deleteUserSet(userSet: string) {
        if(this.userSets[userSet]) {
            delete this.userSets[userSet];
            this.validateUserSets()
                .then(() => {
                    this.save(false);
                    let source = this.userSets;
                    this.usersetList = Object.keys(this.userSets).map(function(name) {
                        return {
                            id: name,
                            name: source[name]
                        };
                    });
                })
                .catch(e => {
                    console.error(e);
                });
        }

        let source = this.userSets;
        if(this.mobileMode != "desktop") {
            this.usersetList = Object.keys(this.userSets)
                .filter(v => {
                    if(v.substr(0, 1) == "m") {
                        return v;
                    }
                })
                .map(function(name) {
                    return {
                        id: name,
                        name: source[name]
                    };
                });
        } else {
            this.usersetList = Object.keys(this.userSets)
                .filter(v => {
                    if(v.substr(0, 1) != "m") {
                        return v;
                    }
                })
                .map(function(name) {
                    return {
                        id: name,
                        name: source[name]
                    };
                });
        }
    }

    private _displayModeForChartDisplayMode: IdisplayModeForChartDisplayMode = {
        wizard: "4",
        charting: "1",
        signals: "4"
    };

    private _prevDisplayModeForChartDisplayMode: IdisplayModeForChartDisplayMode = {
        wizard: "4",
        charting: "1",
        signals: "4"
    };

    private _defaultChartsMobile: {[key: string]: IChartConfig} = {
        ach1: {
            Symbol: "AUD/CAD",
            DisplayMode: ChartDisplayMode.WIZARD,
            WizardSerie: StockSeriesType.LINE,
            ChartingSerie: StockSeriesType.CANDLESTICK,
            ChartButtonsVisible: true,
            ShowTooltip: false,
            Period: {
                wizard: HistoryItemPeriod.Min90,
                charting: HistoryItemPeriod.Min90,
                signals: HistoryItemPeriod.Min90
            },
            BackgroundColor: "#6A8090", //darkTheme().defaultBackground.fill,
            FontColor: "#191818", //darkTheme().defaultFontSettings.fontColor,
            GridColor: "#191818", //darkTheme().defaultGridSettings.stroke,
            MinorGridColor: "#191818", //darkTheme().defaultMinorGridSettings.stroke,
            AxisColor: "#191818", //darkTheme().defaultAxis.stroke,
            LineSeriesColor: "#191818", // "#c77532",
            WizardLineSeriesColor: "#191818", //ChartColorTable.Black,
            WizardLineSeriesWidth: "2",
            CandleStickSerieBorderColor: "#191818", // ChartColorTable.Black,
            CandleStickSerieFallingColor: "#E70304", // ChartColorTable.FaillingColor,
            CandleStickSerieRisingColor: "#0E835E", //ChartColorTable.RaisingColor,
            chartIndicatorInstances: {},
            wizardIndicatorInstances: {},
            chartingshowResistanceLines: true,
            wizardshowResistanceLines: true,
            annotations: {},
            annotationsPerSymbol: {},
            CrosshairColor: "#000000",
            SupportLinesColor: "white"
        },
        ach2: {
            Symbol: "AUD/CAD",
            DisplayMode: ChartDisplayMode.WIZARD,
            WizardSerie: StockSeriesType.LINE,
            ChartingSerie: StockSeriesType.CANDLESTICK,
            ChartButtonsVisible: true,
            ShowTooltip: false,
            Period: {wizard: HistoryItemPeriod.Hr6, charting: HistoryItemPeriod.Hr6, signals: HistoryItemPeriod.Hr6},
            BackgroundColor: "#6A8090", //darkTheme().defaultBackground.fill,
            FontColor: "#191818", //darkTheme().defaultFontSettings.fontColor,
            GridColor: "#191818", //darkTheme().defaultGridSettings.stroke,
            MinorGridColor: "#191818", //darkTheme().defaultMinorGridSettings.stroke,
            AxisColor: "#191818", //darkTheme().defaultAxis.stroke,
            LineSeriesColor: "#191818", // "#c77532",
            WizardLineSeriesColor: "#191818", //ChartColorTable.Black,
            WizardLineSeriesWidth: "2",
            CandleStickSerieBorderColor: "#191818", // ChartColorTable.Black,
            CandleStickSerieFallingColor: "#E70304", // ChartColorTable.FaillingColor,
            CandleStickSerieRisingColor: "#0E835E", //ChartColorTable.RaisingColor,
            chartIndicatorInstances: {},
            wizardIndicatorInstances: {},
            chartingshowResistanceLines: true,
            wizardshowResistanceLines: true,
            annotations: {},
            annotationsPerSymbol: {},
            CrosshairColor: "#000000",
            SupportLinesColor: "white"
        },
        ach3: {
            Symbol: "AUD/CAD",
            DisplayMode: ChartDisplayMode.WIZARD,
            WizardSerie: StockSeriesType.LINE,
            ChartingSerie: StockSeriesType.CANDLESTICK,
            ChartButtonsVisible: true,
            ShowTooltip: false,
            Period: {wizard: HistoryItemPeriod.Hr3, charting: HistoryItemPeriod.Hr3, signals: HistoryItemPeriod.Hr3},
            BackgroundColor: "#6A8090", //darkTheme().defaultBackground.fill,
            FontColor: "#191818", //darkTheme().defaultFontSettings.fontColor,
            GridColor: "#191818", //darkTheme().defaultGridSettings.stroke,
            MinorGridColor: "#191818", //darkTheme().defaultMinorGridSettings.stroke,
            AxisColor: "#191818", //darkTheme().defaultAxis.stroke,
            LineSeriesColor: "#191818", // "#c77532",
            WizardLineSeriesColor: "#191818", //ChartColorTable.Black,
            WizardLineSeriesWidth: "2",
            CandleStickSerieBorderColor: "#191818", // ChartColorTable.Black,
            CandleStickSerieFallingColor: "#E70304", // ChartColorTable.FaillingColor,
            CandleStickSerieRisingColor: "#0E835E", //ChartColorTable.RaisingColor,
            chartIndicatorInstances: {},
            wizardIndicatorInstances: {},
            chartingshowResistanceLines: true,
            wizardshowResistanceLines: true,
            annotations: {},
            annotationsPerSymbol: {},
            CrosshairColor: "#000000",
            SupportLinesColor: "white"
        },
        ach4: {
            Symbol: "AUD/CAD",
            DisplayMode: ChartDisplayMode.WIZARD,
            WizardSerie: StockSeriesType.LINE,
            ChartingSerie: StockSeriesType.CANDLESTICK,
            ChartButtonsVisible: true,
            ShowTooltip: false,
            Period: {
                wizard: HistoryItemPeriod.Min30,
                charting: HistoryItemPeriod.Min30,
                signals: HistoryItemPeriod.Min30
            },
            BackgroundColor: "#6A8090", //darkTheme().defaultBackground.fill,
            FontColor: "#191818", //darkTheme().defaultFontSettings.fontColor,
            GridColor: "#191818", //darkTheme().defaultGridSettings.stroke,
            MinorGridColor: "#191818", //darkTheme().defaultMinorGridSettings.stroke,
            AxisColor: "#191818", //darkTheme().defaultAxis.stroke,
            LineSeriesColor: "#191818", // "#c77532",
            WizardLineSeriesColor: "#191818", //ChartColorTable.Black,
            WizardLineSeriesWidth: "2",
            CandleStickSerieBorderColor: "#191818", // ChartColorTable.Black,
            CandleStickSerieFallingColor: "#E70304", // ChartColorTable.FaillingColor,
            CandleStickSerieRisingColor: "#0E835E", //ChartColorTable.RaisingColor,
            chartIndicatorInstances: {},
            wizardIndicatorInstances: {},
            chartingshowResistanceLines: true,
            wizardshowResistanceLines: true,
            annotations: {},
            annotationsPerSymbol: {},
            CrosshairColor: "#000000",
            SupportLinesColor: "white"
        }
    };

    private _defaultCharts: {[key: string]: IChartConfig} = {
        ach1: {
            Symbol: "AUD/CAD",
            DisplayMode: ChartDisplayMode.WIZARD,
            WizardSerie: StockSeriesType.LINE,
            ChartingSerie: StockSeriesType.CANDLESTICK,
            ChartButtonsVisible: true,
            ShowTooltip: false,
            Period: {
                wizard: HistoryItemPeriod.Hr24,
                charting: HistoryItemPeriod.Hr24,
                signals: HistoryItemPeriod.Hr24
            },
            BackgroundColor: "#6A8090", //darkTheme().defaultBackground.fill,
            FontColor: "#191818", //darkTheme().defaultFontSettings.fontColor,
            GridColor: "#191818", //darkTheme().defaultGridSettings.stroke,
            MinorGridColor: "#191818", //darkTheme().defaultMinorGridSettings.stroke,
            AxisColor: "#191818", //darkTheme().defaultAxis.stroke,
            LineSeriesColor: "#191818", // "#c77532",
            WizardLineSeriesColor: "#191818", //ChartColorTable.Black,
            WizardLineSeriesWidth: "2",
            CandleStickSerieBorderColor: "#191818", // ChartColorTable.Black,
            CandleStickSerieFallingColor: "#E70304", // ChartColorTable.FaillingColor,
            CandleStickSerieRisingColor: "#0E835E", //ChartColorTable.RaisingColor,
            chartIndicatorInstances: {},
            wizardIndicatorInstances: {},
            chartingshowResistanceLines: true,
            wizardshowResistanceLines: true,
            annotations: {},
            annotationsPerSymbol: {},
            CrosshairColor: "#000000",
            SupportLinesColor: null
        },
        ach2: {
            Symbol: "AUD/CAD",
            DisplayMode: ChartDisplayMode.WIZARD,
            WizardSerie: StockSeriesType.LINE,
            ChartingSerie: StockSeriesType.CANDLESTICK,
            ChartButtonsVisible: true,
            ShowTooltip: false,
            Period: {wizard: HistoryItemPeriod.Hr6, charting: HistoryItemPeriod.Hr6, signals: HistoryItemPeriod.Hr6},
            BackgroundColor: "#6A8090", //darkTheme().defaultBackground.fill,
            FontColor: "#191818", //darkTheme().defaultFontSettings.fontColor,
            GridColor: "#191818", //darkTheme().defaultGridSettings.stroke,
            MinorGridColor: "#191818", //darkTheme().defaultMinorGridSettings.stroke,
            AxisColor: "#191818", //darkTheme().defaultAxis.stroke,
            LineSeriesColor: "#191818", // "#c77532",
            WizardLineSeriesColor: "#191818", //ChartColorTable.Black,
            WizardLineSeriesWidth: "2",
            CandleStickSerieBorderColor: "#191818", // ChartColorTable.Black,
            CandleStickSerieFallingColor: "#E70304", // ChartColorTable.FaillingColor,
            CandleStickSerieRisingColor: "#0E835E", //ChartColorTable.RaisingColor,
            chartIndicatorInstances: {},
            wizardIndicatorInstances: {},
            chartingshowResistanceLines: true,
            wizardshowResistanceLines: true,
            annotations: {},
            annotationsPerSymbol: {},
            CrosshairColor: "#000000",
            SupportLinesColor: null
        },
        ach3: {
            Symbol: "AUD/CAD",
            DisplayMode: ChartDisplayMode.WIZARD,
            WizardSerie: StockSeriesType.LINE,
            ChartingSerie: StockSeriesType.CANDLESTICK,
            ChartButtonsVisible: true,
            ShowTooltip: false,
            Period: {wizard: HistoryItemPeriod.Hr3, charting: HistoryItemPeriod.Hr3, signals: HistoryItemPeriod.Hr3},
            BackgroundColor: "#6A8090", //darkTheme().defaultBackground.fill,
            FontColor: "#191818", //darkTheme().defaultFontSettings.fontColor,
            GridColor: "#191818", //darkTheme().defaultGridSettings.stroke,
            MinorGridColor: "#191818", //darkTheme().defaultMinorGridSettings.stroke,
            AxisColor: "#191818", //darkTheme().defaultAxis.stroke,
            LineSeriesColor: "#191818", // "#c77532",
            WizardLineSeriesColor: "#191818", //ChartColorTable.Black,
            WizardLineSeriesWidth: "2",
            CandleStickSerieBorderColor: "#191818", // ChartColorTable.Black,
            CandleStickSerieFallingColor: "#E70304", // ChartColorTable.FaillingColor,
            CandleStickSerieRisingColor: "#0E835E", //ChartColorTable.RaisingColor,
            chartIndicatorInstances: {},
            wizardIndicatorInstances: {},
            chartingshowResistanceLines: true,
            wizardshowResistanceLines: true,
            annotations: {},
            annotationsPerSymbol: {},
            CrosshairColor: "#000000",
            SupportLinesColor: null
        },
        ach4: {
            Symbol: "AUD/CAD",
            DisplayMode: ChartDisplayMode.WIZARD,
            WizardSerie: StockSeriesType.LINE,
            ChartingSerie: StockSeriesType.CANDLESTICK,
            ChartButtonsVisible: true,
            ShowTooltip: false,
            Period: {
                wizard: HistoryItemPeriod.Min30,
                charting: HistoryItemPeriod.Min30,
                signals: HistoryItemPeriod.Min30
            },
            BackgroundColor: "#6A8090", //darkTheme().defaultBackground.fill,
            FontColor: "#191818", //darkTheme().defaultFontSettings.fontColor,
            GridColor: "#191818", //darkTheme().defaultGridSettings.stroke,
            MinorGridColor: "#191818", //darkTheme().defaultMinorGridSettings.stroke,
            AxisColor: "#191818", //darkTheme().defaultAxis.stroke,
            LineSeriesColor: "#191818", // "#c77532",
            WizardLineSeriesColor: "#191818", //ChartColorTable.Black,
            WizardLineSeriesWidth: "2",
            CandleStickSerieBorderColor: "#191818", // ChartColorTable.Black,
            CandleStickSerieFallingColor: "#E70304", // ChartColorTable.FaillingColor,
            CandleStickSerieRisingColor: "#0E835E", //ChartColorTable.RaisingColor,
            chartIndicatorInstances: {},
            wizardIndicatorInstances: {},
            chartingshowResistanceLines: true,
            wizardshowResistanceLines: true,
            annotations: {},
            annotationsPerSymbol: {},
            CrosshairColor: "#000000",
            SupportLinesColor: null
        }
    };

    public loadedFacebookPosts: Subject<boolean> = new Subject<boolean>();
    private _socialMedia: socialMedia = new socialMedia(this);
    public get socialMedia(): socialMedia {
        return this._socialMedia;
    }
    public set socialMedia(value: socialMedia) {
        // this.loadedFacebookPosts = false;
        this._socialMedia = value;
    }

    private _previousLayoutMode: string = "";
    public get previousLayoutMode(): string {
        return this._previousLayoutMode;
    }
    public set previousLayoutMode(value: string) {
        this._previousLayoutMode = value;
    }

    private _changedProperties: {[propertyName: string]: boolean | undefined} = {};
    public preperePropertyName(propertyName: string) {
        while(propertyName.startsWith("_")) {
            propertyName = propertyName.substr(1);
        }
        if("chartDisplayMode" == propertyName) {
            return "workspace-displayMode";
        }
        if("Baskets" == propertyName) {
            return "baskets";
        }
        return propertyName;
    }
    public setChangedProperty(propertyName: string, v: boolean) {
        if(propertyName && propertyName != "") {
            this._changedProperties[this.preperePropertyName(propertyName)] = v || this.isChanged(propertyName);
        }
    }

    public isChanged(propertyName: string) {
        if(propertyName && propertyName != "") {
            return (
                (this._changedProperties[this.preperePropertyName(propertyName)] &&
                    this._changedProperties[this.preperePropertyName(propertyName)] === true) === true
            );
        } else return false;
    }

    public resetChanges() {
        this._changedProperties = {};
        for(var c in this.charts) {
            this.charts[c].resetHasChanges();
        }
    }

    public resetPropertyChanges(propertyName: string) {
        this._changedProperties[this.preperePropertyName(propertyName)] = undefined;
    }

    /**COMPETITION */

    public sendPreviousChallengesRequest() {
        this.dataService.sendRequest({
            Cmd: DataService.TYPE_GET_CHALLENGE_HISTORY__ACCOUNT_LIST,
            Data: {}
        });
    }

    public sendPreviousChallengesHistoryRequest(id: number) {
        this.dataService.sendRequest({
            Cmd: DataService.TYPE_GET_CHALLENGE_HISTORY_TRADE_LIST,
            Data: {
                AccountId: id
            }
        });
    }

    private _isActiveCompetition: boolean = true;
    public get isActiveCompetition(): boolean {
        return this._isActiveCompetition;
    }
    public set isActiveCompetition(value: boolean) {
        this._isActiveCompetition = value;
    }

    private _tournamentsWithoutUser: TournamentWithAccountId[] | null | undefined = [];
    public get tournamentsWithoutUser(): TournamentWithAccountId[] | null | undefined {
        return this._tournamentsWithoutUser;
    }
    public set tournamentsWithoutUser(value: TournamentWithAccountId[] | null | undefined) {
        this._tournamentsWithoutUser = value;
    }

    private _tournamentsWithUser: TournamentWithAccountId[] | null | undefined = [];
    public get tournamentsWithUser(): TournamentWithAccountId[] | null | undefined {
        return this._tournamentsWithUser;
    }
    public set tournamentsWithUser(value: TournamentWithAccountId[] | null | undefined) {
        this._tournamentsWithUser = value;
    }

    public get activeTournaments(): TournamentWithAccountId[] | null | undefined {
        let activeTournaments = null;
        if(this.tournamentsWithUser) {
            let today = moment().utc();
            //  return today.isAfter(moment(this.competition.startDateUtc));

            activeTournaments = this.tournamentsWithUser.filter(v => {
                if(today.isBetween(v.startDateUtc, v.endDateUtc)) {
                    return v;
                }
            });
        }

        return activeTournaments;
    }

    private _competitionAccountList: number[] = [];
    public get competitionAccountList(): (number | undefined)[] {
        let l = this.tournamentsWithUser!.map(v => {
            if(v.accountId > 0) {
                return v.accountId;
            }
        });

        return l;
    }

    private _tournamentWithAccountId: TournamentWithAccountId[] = [];
    public get tournamentWithActiveAccountId(): TournamentWithAccountId[] {
        // this.activeAccountIdBySet
        let selectedTournament: TournamentWithAccountId[] = this.tournamentsWithUser!.filter(v => {
            return v.accountId == this.activeAccountIdBySet;
        });

        if(selectedTournament.length > 0) {
            this.currentTournaments.forEach(v => {
                if(v.id == selectedTournament[0].id) {
                    selectedTournament[0].tournamentAwards = v.tournamentAwards;
                    selectedTournament[0].tournamentAssets = v.tournamentAssets;
                }
            });
        }
        return selectedTournament;
    }
    public set tournamentWithAccountId(value: TournamentWithAccountId[]) {
        this._tournamentWithAccountId = value;
    }

    public accountTypeById(id: number): string | null | undefined {
        let selectedTournament: TournamentWithAccountId[] = this.tournamentsWithUser!.filter(v => {
            return v.accountId == id;
        });

        if(selectedTournament.length > 0) {
            return selectedTournament[0].shortName;
        }

        return "DEMO";
    }

    public accountNameById(id: number | null | undefined): string | null | undefined {
        let selectedTournament: TournamentWithAccountId[] = this.tournamentsWithUser!.filter(v => {
            return v.accountId == id;
        });

        let account: Account[] = this.accounts!.filter(v => {
            return v.id == id;
        });

        if(selectedTournament.length > 0) {
            return selectedTournament[0].shortName + ": " + account[0].accountName;
        }

        return this.currentProvider + ": " + account[0].accountName;
    }




    public getFullAccountNameById(v: number) {


        let account: Account[] = this.accounts!.filter(l => {
            return l.id == v;
        });

        let active = this.allTournamentsAccounts.filter(l => {

            return l.accountId == v;

        })[0];

        if(active !== undefined && this.currentProvider == Providers.DEMO) {
            if(active.tournament !== undefined && active.tournament != null) {
                return active.tournament.shortName + " " + account[0].accountName;
            }
        }

        if(this.currentProvider == "OANDA") {
            return "OANDA" + " " + account[0].accountName;
        }

        if(this.currentProvider == Providers.GAIN) {
            return "GAIN" + " " + account[0].accountName;
        }

        return "DEMO" + " " + account[0].accountName;
        //     }





        return this.accountNameById(v);
    }

    public getFullAccountNameByIdObj(v: number) {

        let account: Account[] = this.accounts!.filter(l => {
            return l.id == v;
        });

        let active = this.allTournamentsAccounts.filter(l => {

            return l.accountId == v;

        })[0];

        if(active !== undefined && this.currentProvider == Providers.DEMO) {
            if(active.tournament !== undefined && active.tournament != null) {
              return {short:active.tournament.shortName, name:account[0].accountName}
            }
        }

        return {short:this.currentProvider, name:account[0].accountName}

    }






    public providerLoginData?: ProviderLoginData;



    public userName: string = "";
    public userPassword: string = "";
    public remember: boolean = false;
    public userId: number = 0;
    public userType: UserType = UserType.Regular;

    private _mobileView: MobileMainView = MobileMainView.PANEL;
    public get mobileView(): MobileMainView {
        return this._mobileView;
    }
    public set mobileView(value: MobileMainView) {
        this._mobileView = value;
        this.save(true);
    }

    public showMobileLandingPage: boolean = false;
    public showLandingPage: boolean = false;
    private _showScannerPage: boolean = false;
    public get showScannerPage(): boolean {
        return this._showScannerPage;
    }
    public set showScannerPage(value: boolean) {
        this._showScannerPage = value;
        if(value == true) {
            this.globaGridMode.setPopScan.next(true);

            this.removeScnannerIndicators();

        }

    }
    public forceDisconnection: boolean = false;
    public activeOrderTab: string = "_orders";
    public lastChartViewNoEntry: ChartDisplayMode = ChartDisplayMode.WIZARD;
    public sumOfUplUsd: number = 0;

    get mobileBasketList() {
        let basketsList: {id: string; label: string}[] = this.Baskets.map((v, index) => {
            let l: {id: string; label: string} = {id: String(index), label: "Basket " + String(1 + index)};
            return l;
        });

        let first: {id: string; label: string}[] = [{id: "-1", label: "Default"}];
        return first.concat(basketsList);
    }

    public entrySignalsMultipleCharts: boolean = false;
    public lastSelectedRowData: any = null;

    private _showLoaderComponent: boolean = false;
    public get showLoaderComponent(): boolean {
        return this._showLoaderComponent;
    }
    public set showLoaderComponent(value: boolean) {
        this._showLoaderComponent = value;
        callNextAsync(this.globaGridMode.showLoaderComponent, value);
    }
    public currentLoadedTitle: string = "...";

    public get allowedAssetType(): boolean {
        //    this.activeSymbolType;

        if(this.availableAssetsForUser!.indexOf(this.activeSymbolType) > -1) {
            return true;
        }

        return false;
    }

    public get availableAssetsForUser() {
        if(this.tournamentWithActiveAccountId[0] != undefined) {
            let availableAssets = this.currentTournaments.filter(v => {
                return v.id == this.tournamentWithActiveAccountId[0].id;
            })[0];

            if(availableAssets !== undefined) {
                return availableAssets.tournamentAssets!.map(v => {
                    return v.asset!.name!.toLowerCase();
                });
            }
            return [];
        }
    }

    get tournamentUserSelected() {
        if(this.competitionAccountList.indexOf(this.activeAccountIdBySet) > -1) {
            return true;
        } else {
            return false;
        }
    }

    public activeTradeDeskTab: string = tradeDeskTabsList.ORDERS;

    public currentAccountMoneyLine: MoneyLine = {
        Balance: 0,
        MarginInUse: 0,
        SumOfPips: 0,
        SumOfUPLUSD: 0,
        SumOfPipsHistory: 0,
        SumOfPLUSDHistory: 0,
        PnL: 0,
        AccountValue: 0
    };

    public currentAccountInformation: any;
    public selectedChallengeHistoryAccInfo: any;

    public historyChallengeAccountMoneyLine: MoneyLine = {
        Balance: 0,
        MarginInUse: 0,
        SumOfPips: 0,
        SumOfUPLUSD: 0,
        SumOfPipsHistory: 0,
        SumOfPLUSDHistory: 0,
        PnL: 0,
        AccountValue: 0
    };
    public visibleHistoryData: IOrdersHistoryData[] = [];
    public visibleHistoryChallengeData: IOrdersHistoryData[] = [];
    // private _dateFilterType: dateFilterTypes = dateFilterTypes.ALL;
    // public get dateFilterType (): dateFilterTypes {
    //     return this._dateFilterType;
    // }
    // public set dateFilterType ( value: dateFilterTypes ) {
    //     this._dateFilterType = value;
    // }

    public pdfReportHistoryDateStrChallenge: string = "";
    public pdfReportHistoryDateRange: {from?: moment.Moment, to?: moment.Moment} = {};
    public pdfReportHistoryDateStr: string = "";

    public dateFilterType: string = "all";

    public fromDateFilter: NgbDateStruct | any;

    public toDateFilter: NgbDateStruct | any;

    //////////////

    public dateFilterTypeChallenge: string = "all";
    public fromDateFilterChallenge: NgbDateStruct | any;
    public toDateFilterChallenge: NgbDateStruct | any;
    private _allowedForexSymbols: string[] = [];
    public get allowedForexSymbols(): string[] {
        return this._allowedForexSymbols;
    }
    public set allowedForexSymbols(value: string[]) {
        //   debugger;
        this._allowedForexSymbols = value;
    }

    public currentRegisteringChallenge?: TournamentWithAccountId;

    public get enabledAdSpace(): boolean {
        return this.dataService.EnableAdSpace;
    }

    public sendLogin(username: string, password: string, specialToken: string = "", provider: string = "DEMO") {
        let logon: LoginRequestModel = new LoginRequestModel();
        logon.Password = password;
        logon.Username = username;
        logon.SpecialToken = specialToken;
        logon.Provider = provider;
        this.userName = username;
        this.userPassword = password;

        this.dataService.sendRequest({
            Cmd: DataService.TYPE_LOGON,
            Data: logon
        });

        if(this.cookieService.getCookie("orderLoginAction") == "true") {
            //ShowModalOrderEntry()
            this.cookieService.setCookie("orderLoginAction", "false", 1, "/");
            let tradeCookieValue = this.cookieService.getCookie("orderLoginActionTrade");
            if(tradeCookieValue && tradeCookieValue !== "") {
                try {
                    let tradeObj: TradeRequestModel = JSON.parse(this.cookieService.getCookie("orderLoginActionTrade"));
                } catch(error) {
                    console.log(`Wrong trade cookie: ${ tradeCookieValue } throws exception: ${ error }`);
                }
            }
        }

        // if (fbq != null) {
        //     fbq("trackCustom", "UserLogIn");
        // }
    }

    public refreshAction() {
        console.log(this.dataService.periodCache);
        this.dataService.periodCache = {};
        Object.keys(this.charts).forEach(chartId => {
            //console.log(chartId, this.charts[chartId]!.instance!.period);
            if (this.charts[chartId] && this.charts[chartId].instance) {
                this.charts[chartId]!.instance!.hardRefreshPeriod();
            }
            //this.charts[chartId]!.instance!.hardRefreshPeriod();
            //   this.charts[chartId]!.instance!.saveUserIndicators();
        });
        console.log(this.dataService.periodCache);
        //     this.globaGridMode.refreshProviderSignal.next(true);
    }

    subscribeForLoginResponse() {
        this.dataService.dataSubscriber.subscribe(response => {
            if(response) {
                if(this.loggedIn == true) {
                    // this.activeModal.close();
                }

                switch(response.Type) {
                    case "LoginRs":
                        var loginRs: LoginRs = <LoginRs> response;

                        if(loginRs.OK == true) {

                            this.userName = loginRs.UserName;
                            this.cookieService.setCookie("orderLoginAction", "true", 1, "/");
                            this.cookieService.setCookie("IsLoggedIn", "true", 1, "/");

                            this.userType = loginRs.UserType == "Regular" ? UserType.Regular : UserType.Tournament;
                            this._loggedIn = true;
                            this._IsLoged = true;


                            // this.providerLoginData[Providers.DEMO] ={user:this.userName, password:this.userPassword};
                            this.ProcessLoginResponse(loginRs, this.userName, this.userPassword, this.remember)
                                .then(() => {
                                    //this.activeModal.close();
                                    //  this.providerLoginData[Providers.DEMO] ={user:this.userName, password:this.userPassword};
                                })
                                .catch(e => {
                                    console.error(e);
                                });

                        } else {
                            //this.loginError = true;
                            // ShowLoginModal(this.modalService).then(
                            //     () => {
                            //         //  this.workspace.loggedIn = true;
                            //     },
                            //     () => {
                            //         this.dataService.loggedIn = false;
                            //     }
                            // );
                        }

                        break;
                }
            }
        });
    }

    public CurrentScannerComponent?: ScannerBaseComponentComponent = undefined;

    public addFundsUrl() {
        return "https://www.oanda.com/account"
    }

    public openAccountUrl() {
        //return "https://fxtrade.oanda.com/your_account/fxtrade/register/individual/beforeyoubegin?ib=103520";
        return "https://fxtrade.oanda.com/your_account/fxtrade/register/individual/beforeyoubegin?ib=1507134";
    }

    public get newOrderLayout():boolean
    {
        return true;//this.debugVisibility;
    }
}

export function ProxyWorkspace(
    app: ApplicationRef,
    chartDisplayModeService: ChartDisplayModeService,
    globalGridModeService: GlobalGridModeService,
    quoteTabsActiveModeService: QuoteTabsActiveModeService,
    symbolTypeService: SymbolTypeService,
    dataService: DataService,
    chartButtonsVisibleService: ChartButtonsVisibleService,
    showChartTooltipService: ShowChartTooltipService,
    activeLayoutTypeService: ChartLayoutModeService,
    landingClickState: LandingPageClickStateService,
    settingsClient: SettingsClient,
    tournamentClient: TournamentClient,
    accountsClient: AccountsClient,
    homeClient:HomeClient,
    http: HttpClient,
    routingService: RoutingService,
    cookieService: CookiesService,
    appStoreClient: AppStoreClientEx,
    accountClient: AccountClient,
) {
    const proxy = new Proxy(
        new Workspace(
            app,
            chartDisplayModeService,
            globalGridModeService,
            quoteTabsActiveModeService,
            symbolTypeService,
            dataService,
            chartButtonsVisibleService,
            showChartTooltipService,
            activeLayoutTypeService,
            landingClickState,
            settingsClient,
            tournamentClient,
            homeClient,
            accountsClient,
            http,
            routingService,
            cookieService,
            appStoreClient,
            accountClient
        ),
        {
            set(target: Workspace, p: string, value: any, receiver: any): boolean {
                if((target as any)[p] !== value) {
                    (target as any)[p] = value;

                    target.setChangedProperty(p, true);
                } else {
                    (target as any)[p] = value;
                }
                if(app && p.toLowerCase().startsWith("scan")) {
                    target.AppTick();
                }
                return true;
            }
        }
    );
    proxy.resetChanges();
    return proxy;
}

export class AccountProvider extends Account implements IProviderAccount {
    public accountProviderId?: string;
    public Currency?: string;

    constructor(data?: IProviderAccount) {
        super();
        this.init(data);

        if(data) this.accountProviderId = data.accountProviderId;
        if(data) this.Currency = data.Currency;
    }
}

export interface IProviderAccount extends IAccount {
    id: number;
    userId?: number | null;
    accountName?: string | null;
    balance?: number | null;
    pnL: number;
    tournamentUserAndAccount?: TournamentUserAndAccount[] | null;
    accountProviderId?: string;
    Currency?: string;
}
